window.Modernizr=function(e,t,n){function r(e){h.cssText=e}function o(e,t){return typeof e===t}function i(e,t){return!!~(""+e).indexOf(t)}function a(e,t){for(var r in e){var o=e[r];if(!i(o,"-")&&h[o]!==n)return"pfx"!=t||o}return!1}function c(e,t,r){for(var i in e){var a=t[e[i]];if(a!==n)return!1===r?e[i]:o(a,"function")?a.bind(r||t):a}return!1}function l(e,t,n){var r=e.charAt(0).toUpperCase()+e.slice(1),i=(e+" "+x.join(r+" ")+r).split(" ");return o(t,"string")||o(t,"undefined")?a(i,t):c(i=(e+" "+w.join(r+" ")+r).split(" "),t,n)}var s,u,f={},d=t.documentElement,p="modernizr",m=t.createElement(p),h=m.style,g=t.createElement("input"),v=":)",y={}.toString,b=" -webkit- -moz- -o- -ms- ".split(" "),E="Webkit Moz O ms",x=E.split(" "),w=E.toLowerCase().split(" "),S="http://www.w3.org/2000/svg",C={},k={},T={},j=[],N=j.slice,M=function(e,n,r,o){var i,a,c,l,s=t.createElement("div"),u=t.body,f=u||t.createElement("body");if(parseInt(r,10))for(;r--;)(c=t.createElement("div")).id=o?o[r]:p+(r+1),s.appendChild(c);return i=["&#173;",'<style id="s',p,'">',e,"</style>"].join(""),s.id=p,(u?s:f).innerHTML+=i,f.appendChild(s),u||(f.style.background="",f.style.overflow="hidden",l=d.style.overflow,d.style.overflow="hidden",d.appendChild(f)),a=n(s,e),u?s.parentNode.removeChild(s):(f.parentNode.removeChild(f),d.style.overflow=l),!!a},P=function(){var e={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return function(r,i){i=i||t.createElement(e[r]||"div");var a=(r="on"+r)in i;return a||(i.setAttribute||(i=t.createElement("div")),i.setAttribute&&i.removeAttribute&&(i.setAttribute(r,""),a=o(i[r],"function"),o(i[r],"undefined")||(i[r]=n),i.removeAttribute(r))),i=null,a}}(),A={}.hasOwnProperty;for(var D in u=o(A,"undefined")||o(A.call,"undefined")?function(e,t){return t in e&&o(e.constructor.prototype[t],"undefined")}:function(e,t){return A.call(e,t)},Function.prototype.bind||(Function.prototype.bind=function(e){var t=this;if("function"!=typeof t)throw new TypeError;var n=N.call(arguments,1),r=function(){if(this instanceof r){var o=function(){};o.prototype=t.prototype;var i=new o,a=t.apply(i,n.concat(N.call(arguments)));return Object(a)===a?a:i}return t.apply(e,n.concat(N.call(arguments)))};return r}),C.flexbox=function(){return l("flexWrap")},C.flexboxlegacy=function(){return l("boxDirection")},C.canvas=function(){var e=t.createElement("canvas");return!!e.getContext&&!!e.getContext("2d")},C.canvastext=function(){return!!f.canvas&&!!o(t.createElement("canvas").getContext("2d").fillText,"function")},C.webgl=function(){return!!e.WebGLRenderingContext},C.touch=function(){var n;return"ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch?n=!0:M(["@media (",b.join("touch-enabled),("),p,")","{#modernizr{top:9px;position:absolute}}"].join(""),(function(e){n=9===e.offsetTop})),n},C.geolocation=function(){return"geolocation"in navigator},C.postmessage=function(){return!!e.postMessage},C.websqldatabase=function(){return!!e.openDatabase},C.indexedDB=function(){return!!l("indexedDB",e)},C.hashchange=function(){return P("hashchange",e)&&(t.documentMode===n||t.documentMode>7)},C.history=function(){return!!e.history&&!!history.pushState},C.draganddrop=function(){var e=t.createElement("div");return"draggable"in e||"ondragstart"in e&&"ondrop"in e},C.websockets=function(){return"WebSocket"in e||"MozWebSocket"in e},C.rgba=function(){return r("background-color:rgba(150,255,150,.5)"),i(h.backgroundColor,"rgba")},C.hsla=function(){return r("background-color:hsla(120,40%,100%,.5)"),i(h.backgroundColor,"rgba")||i(h.backgroundColor,"hsla")},C.multiplebgs=function(){return r("background:url(https://),url(https://),red url(https://)"),/(url\s*\(.*?){3}/.test(h.background)},C.backgroundsize=function(){return l("backgroundSize")},C.borderimage=function(){return l("borderImage")},C.borderradius=function(){return l("borderRadius")},C.boxshadow=function(){return l("boxShadow")},C.textshadow=function(){return""===t.createElement("div").style.textShadow},C.opacity=function(){return function(e,t){r(b.join(e+";")+(t||""))}("opacity:.55"),/^0.55$/.test(h.opacity)},C.cssanimations=function(){return l("animationName")},C.csscolumns=function(){return l("columnCount")},C.cssgradients=function(){var e="background-image:";return r((e+"-webkit- ".split(" ").join("gradient(linear,left top,right bottom,from(#9f9),to(white));"+e)+b.join("linear-gradient(left top,#9f9, white);"+e)).slice(0,-e.length)),i(h.backgroundImage,"gradient")},C.cssreflections=function(){return l("boxReflect")},C.csstransforms=function(){return!!l("transform")},C.csstransforms3d=function(){var e=!!l("perspective");return e&&"webkitPerspective"in d.style&&M("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",(function(t,n){e=9===t.offsetLeft&&3===t.offsetHeight})),e},C.csstransitions=function(){return l("transition")},C.fontface=function(){var e;return M('@font-face {font-family:"font";src:url("https://")}',(function(n,r){var o=t.getElementById("smodernizr"),i=o.sheet||o.styleSheet,a=i?i.cssRules&&i.cssRules[0]?i.cssRules[0].cssText:i.cssText||"":"";e=/src/i.test(a)&&0===a.indexOf(r.split(" ")[0])})),e},C.generatedcontent=function(){var e;return M(["#",p,"{font:0/0 a}#",p,':after{content:"',v,'";visibility:hidden;font:3px/1 a}'].join(""),(function(t){e=t.offsetHeight>=3})),e},C.video=function(){var e=t.createElement("video"),n=!1;try{(n=!!e.canPlayType)&&((n=new Boolean(n)).ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),n.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),n.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""))}catch(e){}return n},C.audio=function(){var e=t.createElement("audio"),n=!1;try{(n=!!e.canPlayType)&&((n=new Boolean(n)).ogg=e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),n.mp3=e.canPlayType("audio/mpeg;").replace(/^no$/,""),n.wav=e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),n.m4a=(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,""))}catch(e){}return n},C.localstorage=function(){try{return localStorage.setItem(p,p),localStorage.removeItem(p),!0}catch(e){return!1}},C.sessionstorage=function(){try{return sessionStorage.setItem(p,p),sessionStorage.removeItem(p),!0}catch(e){return!1}},C.webworkers=function(){return!!e.Worker},C.applicationcache=function(){return!!e.applicationCache},C.svg=function(){return!!t.createElementNS&&!!t.createElementNS(S,"svg").createSVGRect},C.inlinesvg=function(){var e=t.createElement("div");return e.innerHTML="<svg/>",(e.firstChild&&e.firstChild.namespaceURI)==S},C.smil=function(){return!!t.createElementNS&&/SVGAnimate/.test(y.call(t.createElementNS(S,"animate")))},C.svgclippaths=function(){return!!t.createElementNS&&/SVGClipPath/.test(y.call(t.createElementNS(S,"clipPath")))},C)u(C,D)&&(s=D.toLowerCase(),f[s]=C[D](),j.push((f[s]?"":"no-")+s));return f.input||(f.input=function(n){for(var r=0,o=n.length;r<o;r++)T[n[r]]=n[r]in g;return T.list&&(T.list=!!t.createElement("datalist")&&!!e.HTMLDataListElement),T}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),f.inputtypes=function(e){for(var r,o,i,a=0,c=e.length;a<c;a++)g.setAttribute("type",o=e[a]),(r="text"!==g.type)&&(g.value=v,g.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(o)&&g.style.WebkitAppearance!==n?(d.appendChild(g),r=(i=t.defaultView).getComputedStyle&&"textfield"!==i.getComputedStyle(g,null).WebkitAppearance&&0!==g.offsetHeight,d.removeChild(g)):/^(search|tel)$/.test(o)||(r=/^(url|email)$/.test(o)?g.checkValidity&&!1===g.checkValidity():g.value!=v)),k[e[a]]=!!r;return k}("search tel url email datetime date month week time datetime-local number range color".split(" "))),f.addTest=function(e,t){if("object"==typeof e)for(var r in e)u(e,r)&&f.addTest(r,e[r]);else{if(e=e.toLowerCase(),f[e]!==n)return f;t="function"==typeof t?t():t,d.className+=" "+(t?"":"no-")+e,f[e]=t}return f},r(""),m=g=null,function(e,t){function n(){var e=m.elements;return"string"==typeof e?e.split(" "):e}function r(e){var t=p[e[f]];return t||(t={},d++,e[f]=d,p[d]=t),t}function o(e,n,o){return n||(n=t),c?n.createElement(e):(o||(o=r(n)),!(i=o.cache[e]?o.cache[e].cloneNode():u.test(e)?(o.cache[e]=o.createElem(e)).cloneNode():o.createElem(e)).canHaveChildren||s.test(e)||i.tagUrn?i:o.frag.appendChild(i));var i}function i(e){e||(e=t);var i=r(e);return m.shivCSS&&!a&&!i.hasCSS&&(i.hasCSS=!!function(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),c||function(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return m.shivMethods?o(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+n().join().replace(/[\w\-]+/g,(function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'}))+");return n}")(m,t.frag)}(e,i),e}var a,c,l=e.html5||{},s=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,u=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,f="_html5shiv",d=0,p={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",a="hidden"in e,c=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return void 0===e.cloneNode||void 0===e.createDocumentFragment||void 0===e.createElement}()}catch(e){a=!0,c=!0}}();var m={elements:l.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",version:"3.7.0",shivCSS:!1!==l.shivCSS,supportsUnknownElements:c,shivMethods:!1!==l.shivMethods,type:"default",shivDocument:i,createElement:o,createDocumentFragment:function(e,o){if(e||(e=t),c)return e.createDocumentFragment();for(var i=(o=o||r(e)).frag.cloneNode(),a=0,l=n(),s=l.length;a<s;a++)i.createElement(l[a]);return i}};e.html5=m,i(t)}(this,t),f._version="2.7.0",f._prefixes=b,f._domPrefixes=w,f._cssomPrefixes=x,f.mq=function(t){var n,r=e.matchMedia||e.msMatchMedia;return r?r(t).matches:(M("@media "+t+" { #"+p+" { position: absolute; } }",(function(t){n="absolute"==(e.getComputedStyle?getComputedStyle(t,null):t.currentStyle).position})),n)},f.hasEvent=P,f.testProp=function(e){return a([e])},f.testAllProps=l,f.testStyles=M,d.className=d.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+" js "+j.join(" "),f}(this,this.document),function(e,t,n){function r(e){return"[object Function]"==g.call(e)}function o(e){return"string"==typeof e}function i(){}function a(e){return!e||"loaded"==e||"complete"==e||"uninitialized"==e}function c(){var e=v.shift();y=1,e?e.t?m((function(){("c"==e.t?d.injectCss:d.injectJs)(e.s,0,e.a,e.x,e.e,1)}),0):(e(),c()):y=0}function l(e,n,r,o,i,l,s){function u(t){if(!p&&a(f.readyState)&&(b.r=p=1,!y&&c(),f.onload=f.onreadystatechange=null,t))for(var r in"img"!=e&&m((function(){x.removeChild(f)}),50),T[n])T[n].hasOwnProperty(r)&&T[n][r].onload()}s=s||d.errorTimeout;var f=t.createElement(e),p=0,g=0,b={t:r,s:n,e:i,a:l,x:s};1===T[n]&&(g=1,T[n]=[]),"object"==e?f.data=n:(f.src=n,f.type=e),f.width=f.height="0",f.onerror=f.onload=f.onreadystatechange=function(){u.call(this,g)},v.splice(o,0,b),"img"!=e&&(g||2===T[n]?(x.insertBefore(f,E?null:h),m(u,s)):T[n].push(f))}function s(e,t,n,r,i){return y=0,t=t||"j",o(e)?l("c"==t?S:w,e,t,this.i++,n,r,i):(v.splice(this.i++,0,e),1==v.length&&c()),this}function u(){var e=d;return e.loader={load:s,i:0},e}var f,d,p=t.documentElement,m=e.setTimeout,h=t.getElementsByTagName("script")[0],g={}.toString,v=[],y=0,b="MozAppearance"in p.style,E=b&&!!t.createRange().compareNode,x=E?p:h.parentNode,w=(p=e.opera&&"[object Opera]"==g.call(e.opera),p=!!t.attachEvent&&!p,b?"object":p?"script":"img"),S=p?"script":w,C=Array.isArray||function(e){return"[object Array]"==g.call(e)},k=[],T={},j={timeout:function(e,t){return t.length&&(e.timeout=t[0]),e}};d=function(e){function t(e,t,n,o,i){var a=function(e){e=e.split("!");var t,n,r,o=k.length,i=e.pop(),a=e.length;for(i={url:i,origUrl:i,prefixes:e},n=0;n<a;n++)r=e[n].split("="),(t=j[r.shift()])&&(i=t(i,r));for(n=0;n<o;n++)i=k[n](i);return i}(e),c=a.autoCallback;a.url.split(".").pop().split("?").shift(),a.bypass||(t&&(t=r(t)?t:t[e]||t[o]||t[e.split("/").pop().split("?")[0]]),a.instead?a.instead(e,t,n,o,i):(T[a.url]?a.noexec=!0:T[a.url]=1,n.load(a.url,a.forceCSS||!a.forceJS&&"css"==a.url.split(".").pop().split("?").shift()?"c":undefined,a.noexec,a.attrs,a.timeout),(r(t)||r(c))&&n.load((function(){u(),t&&t(a.origUrl,i,o),c&&c(a.origUrl,i,o),T[a.url]=2}))))}function n(e,n){function a(e,i){if(e){if(o(e))i||(f=function(){var e=[].slice.call(arguments);d.apply(this,e),p()}),t(e,f,n,0,s);else if(Object(e)===e)for(l in c=function(){var t,n=0;for(t in e)e.hasOwnProperty(t)&&n++;return n}(),e)e.hasOwnProperty(l)&&(!i&&!--c&&(r(f)?f=function(){var e=[].slice.call(arguments);d.apply(this,e),p()}:f[l]=function(e){return function(){var t=[].slice.call(arguments);e&&e.apply(this,t),p()}}(d[l])),t(e[l],f,n,l,s))}else!i&&p()}var c,l,s=!!e.test,u=e.load||e.both,f=e.callback||i,d=f,p=e.complete||i;a(s?e.yep:e.nope,!!u),u&&a(u)}var a,c,l=this.yepnope.loader;if(o(e))t(e,0,l,0);else if(C(e))for(a=0;a<e.length;a++)o(c=e[a])?t(c,0,l,0):C(c)?d(c):Object(c)===c&&n(c,l);else Object(e)===e&&n(e,l)},d.addPrefix=function(e,t){j[e]=t},d.addFilter=function(e){k.push(e)},d.errorTimeout=1e4,null==t.readyState&&t.addEventListener&&(t.readyState="loading",t.addEventListener("DOMContentLoaded",f=function(){t.removeEventListener("DOMContentLoaded",f,0),t.readyState="complete"},0)),e.yepnope=u(),e.yepnope.executeStack=c,e.yepnope.injectJs=function(e,n,r,o,l,s){var u,f,p=t.createElement("script");o=o||d.errorTimeout;for(f in p.src=e,r)p.setAttribute(f,r[f]);n=s?c:n||i,p.onreadystatechange=p.onload=function(){!u&&a(p.readyState)&&(u=1,n(),p.onload=p.onreadystatechange=null)},m((function(){u||(u=1,n(1))}),o),l?p.onload():h.parentNode.insertBefore(p,h)},e.yepnope.injectCss=function(e,n,r,o,a,l){var s;o=t.createElement("link"),n=l?c:n||i;for(s in o.href=e,o.rel="stylesheet",o.type="text/css",r)o.setAttribute(s,r[s]);a||(h.parentNode.insertBefore(o,h),m(n,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
//# sourceMappingURL=modernizr.2.7.0.min.js.map

!function(t){function e(t){return"object"==typeof t?t:{top:t,left:t}}var n=t.scrollTo=function(e,n,o){return t(window).scrollTo(e,n,o)};n.defaults={axis:"xy",duration:1.3<=parseFloat(t.fn.jquery)?0:1,limit:!0},n.window=function(e){return t(window)._scrollable()},t.fn._scrollable=function(){return this.map((function(){if(this.nodeName&&-1==t.inArray(this.nodeName.toLowerCase(),["iframe","#document","html","body"]))return this;var e=(this.contentWindow||this).document||this.ownerDocument||this;return/webkit/i.test(navigator.userAgent)||"BackCompat"==e.compatMode?e.body:e.documentElement}))},t.fn.scrollTo=function(o,i,r){return"object"==typeof i&&(r=i,i=0),"function"==typeof r&&(r={onAfter:r}),"max"==o&&(o=9e9),r=t.extend({},n.defaults,r),i=i||r.duration,r.queue=r.queue&&1<r.axis.length,r.queue&&(i/=2),r.offset=e(r.offset),r.over=e(r.over),this._scrollable().each((function(){function s(t){c.animate(l,i,r.easing,t&&function(){t.call(this,f,r)})}if(null!=o){var a,u=this,c=t(u),f=o,l={},d=c.is("html,body");switch(typeof f){case"number":case"string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(f)){f=e(f);break}if(!(f=t(f,this)).length)return;case"object":(f.is||f.style)&&(a=(f=t(f)).offset())}t.each(r.axis.split(""),(function(t,e){var o="x"==e?"Left":"Top",i=o.toLowerCase(),m="scroll"+o,h=u[m],w=n.max(u,e);a?(l[m]=a[i]+(d?0:h-c.offset()[i]),r.margin&&(l[m]-=parseInt(f.css("margin"+o))||0,l[m]-=parseInt(f.css("border"+o+"Width"))||0),l[m]+=r.offset[i]||0,r.over[i]&&(l[m]+=f["x"==e?"width":"height"]()*r.over[i])):(o=f[i],l[m]=o.slice&&"%"==o.slice(-1)?parseFloat(o)/100*w:o),r.limit&&/^\d+$/.test(l[m])&&(l[m]=0>=l[m]?0:Math.min(l[m],w)),!t&&r.queue&&(h!=l[m]&&s(r.onAfterFirst),delete l[m])})),s(r.onAfter)}})).end()},n.max=function(e,n){var o="scroll"+(i="x"==n?"Width":"Height");if(!t(e).is("html,body"))return e[o]-t(e)[i.toLowerCase()]();var i="client"+i,r=e.ownerDocument.documentElement,s=e.ownerDocument.body;return Math.max(r[o],s[o])-Math.min(r[i],s[i])}}(jQuery);
//# sourceMappingURL=jquery.scrollTo.1.4.7.min.js.map

!function(t){var e=location.href.replace(/#.*/,""),o=t.localScroll=function(e){t("body").localScroll(e)};function a(e,o,a){var n=o.hash.slice(1),r=document.getElementById(n)||document.getElementsByName(n)[0];if(r){e&&e.preventDefault();var i=t(a.target);if(!(a.lock&&i.is(":animated")||a.onBefore&&!1===a.onBefore(e,r,i))){if(a.stop&&i._scrollable().stop(!0),a.hash){var l=a.offset;l=l&&l.top||l||0;var s=r.id==n?"id":"name",c=t("<a> </a>").attr(s,n).css({position:"absolute",top:t(window).scrollTop()+l,left:t(window).scrollLeft()});r[s]="",t("body").prepend(c),location=o.hash,c.remove(),r[s]=n}i.scrollTo(r,a).trigger("notify.serialScroll",[r])}}}o.defaults={duration:1e3,axis:"y",event:"click",stop:!0,target:window},o.hash=function(e){if(location.hash){if((e=t.extend({},o.defaults,e)).hash=!1,e.reset){var n=e.duration;delete e.duration,t(e.target).scrollTo(0,e),e.duration=n}a(0,location,e)}},t.fn.localScroll=function(n){return(n=t.extend({},o.defaults,n)).lazy?this.on(n.event,(function(e){var o=t([e.target,e.target.parentNode]).filter(r)[0];o&&a(e,o,n)})):this.find("a,area").filter(r).on(n.event,(function(t){a(t,this,n)})).end().end();function r(){return!!this.href&&!!this.hash&&this.href.replace(this.hash,"")==e&&(!n.filter||t(this).is(n.filter))}}}(jQuery);
//# sourceMappingURL=jquery.localScroll.1.3.1.min.js.map

/*
 * jQuery selectBox - A cosmetic, styleable replacement for SELECT elements
 *
 * Licensed under the MIT license: http://opensource.org/licenses/MIT
 *
 * v1.2.0
 *
 * https://github.com/marcj/jquery-selectBox
 */
;(function ($) {

    /**
     * SelectBox class.
     *
     * @param {HTMLElement|jQuery} select If it's a jQuery object, we use the first element.
     * @param {Object}             options
     * @constructor
     */
    var SelectBox = this.SelectBox = function (select, options) {
        if (select instanceof jQuery) {
            if (select.length > 0) {
                select = select[0];
            } else {
                return;
            }
        }

        this.typeTimer     = null;
        this.typeSearch    = '';
        this.isMac         = navigator.platform.match(/mac/i);
        options            = 'object' === typeof options ? options :  {};
        this.selectElement = select;

        // Disable for iOS devices (their native controls are more suitable for a touch device)
        if (!options.mobile && navigator.userAgent.match(/iPhone|Android|IEMobile|BlackBerry/i)) {
            return false;
        }

        // Element must be a select control
        if ('select' !== select.tagName.toLowerCase()) {
            return false;
        }

        this.init(options);
    };

    /**
     * @type {String}
     */
    SelectBox.prototype.version = '1.2.0';

    /**
     * @param {Object} options
     *
     * @returns {Boolean}
     */
    SelectBox.prototype.init = function (options) {
        var select = $(this.selectElement);
        if (select.data('selectBox-control')) {
            return false;
        }

        var control    = $('<a class="selectBox" />')
            , inline   = select.attr('multiple') || parseInt(select.attr('size')) > 1
            , settings = options || {}
            , tabIndex = parseInt(select.prop('tabindex')) || 0
            , self     = this;

        control
            // .width(select.outerWidth())
            .addClass(select.attr('class'))
            .attr('title', select.attr('title') || '')
            .attr('tabindex', tabIndex)
            .css('display', 'inline-block')
            .on('focus.selectBox', function () {
                if (this !== document.activeElement && document.body !== document.activeElement) {
                    $(document.activeElement).blur();
                }
                if (control.hasClass('selectBox-active')) {
                    return;
                }
                control.addClass('selectBox-active');
                select.trigger('focus');
            })
            .on('blur.selectBox', function () {
                if (!control.hasClass('selectBox-active')) {
                    return;
                }
                control.removeClass('selectBox-active');
                select.trigger('blur');
            });

        if (!$(window).data('selectBox-bindings')) {
            $(window)
                .data('selectBox-bindings', true)
                .on('scroll.selectBox', (settings.hideOnWindowScroll) ? this.hideMenus : $.noop)
                .on('resize.selectBox', this.hideMenus);
        }

        if (select.attr('disabled')) {
            control.addClass('selectBox-disabled');
        }

        // Focus on control when label is clicked
        select.on('click.selectBox', function (event) {
            control.focus();
            event.preventDefault();
        });

        // Generate control
        if (inline) {
            // Inline controls
            options = this.getOptions('inline');

            control
                .append(options)
                .data('selectBox-options', options).addClass('selectBox-inline selectBox-menuShowing')
                .on('keydown.selectBox', function (event) {
                    self.handleKeyDown(event);
                })
                .on('keypress.selectBox',function (event) {
                    self.handleKeyPress(event);
                })
                .on('mousedown.selectBox',function (event) {
                    if (1 !== event.which) {
                        return;
                    }
                    if ($(event.target).is('A.selectBox-inline')) {
                        event.preventDefault();
                    }
                    if (!control.hasClass('selectBox-focus')) {
                        control.focus();
                    }
                })
                .insertAfter(select);

            // Auto-height based on size attribute
            if (!select[0].style.height) {
                var size = select.attr('size') ? parseInt(select.attr('size')) : 5;
                // Draw a dummy control off-screen, measure, and remove it
                var tmp = control
                    .clone()
                    .removeAttr('id')
                    .css({
                        position: 'absolute',
                        top: '-9999em'
                    })
                    .show()
                    .appendTo('body');
                tmp.find('.selectBox-options').html('<li><a>\u00A0</a></li>');
                var optionHeight = parseInt(tmp.find('.selectBox-options A:first').html('&nbsp;').outerHeight());
                tmp.remove();
                control.height(optionHeight * size);
            }
            this.disableSelection(control);
        } else {
            // Dropdown controls
            var label = $('<span class="selectBox-label" />'),
                arrow = $('<span class="selectBox-arrow" />');

            // Update label
            label.attr('class', this.getLabelClass()).text(this.getLabelText());
            options = this.getOptions('dropdown');
            options.appendTo('BODY');

            control
                .data('selectBox-options', options)
                .addClass('selectBox-dropdown')
                .append(label)
                .append(arrow)
                .on('mousedown.selectBox', function (event) {
                    if (1 === event.which) {
                        if (control.hasClass('selectBox-menuShowing')) {
                            self.hideMenus();
                        } else {
                            event.stopPropagation();
                            // Webkit fix to prevent premature selection of options
                            options
                                .data('selectBox-down-at-x', event.screenX)
                                .data('selectBox-down-at-y', event.screenY);
                            self.showMenu();
                        }
                    }
                })
                .on('keydown.selectBox', function (event) {
                    self.handleKeyDown(event);
                })
                .on('keypress.selectBox', function (event) {
                    self.handleKeyPress(event);
                })
                .on('open.selectBox',function (event, triggerData) {
                    if (triggerData && triggerData._selectBox === true) {
                        return;
                    }
                    self.showMenu();
                })
                .on('close.selectBox', function (event, triggerData) {
                    if (triggerData && triggerData._selectBox === true) {
                        return;
                    }
                    self.hideMenus();
                })
                .insertAfter(select);

            // Set label width
            // var labelWidth =
            //         control.width()
            //       - arrow.outerWidth()
            //       - (parseInt(label.css('paddingLeft')) || 0)
            //       - (parseInt(label.css('paddingRight')) || 0);

            // label.width(labelWidth);
            this.disableSelection(control);
        }
        // Store data for later use and show the control
        select
            .addClass('selectBox')
            .data('selectBox-control', control)
            .data('selectBox-settings', settings)
            .hide();
    };

    /**
     * @param {String} type 'inline'|'dropdown'
     * @returns {jQuery}
     */
    SelectBox.prototype.getOptions = function (type) {
        var options;
        var select = $(this.selectElement);
        var self   = this;
        // Private function to handle recursion in the getOptions function.
        var _getOptions = function (select, options) {
            // Loop through the set in order of element children.
            select.children('OPTION, OPTGROUP').each(function () {
                // If the element is an option, add it to the list.
                if ($(this).is('OPTION')) {
                    // Check for a value in the option found.
                    if ($(this).length > 0) {
                        // Create an option form the found element.
                        self.generateOptions($(this), options);
                    } else {
                        // No option information found, so add an empty.
                        options.append('<li>\u00A0</li>');
                    }
                } else {
                    // If the element is an option group, add the group and call this function on it.
                    var optgroup = $('<li class="selectBox-optgroup" />');
                    optgroup.text($(this).attr('label'));
                    options.append(optgroup);
                    options = _getOptions($(this), options);
                }
            });
            // Return the built strin
            return options;
        };

        switch (type) {
            case 'inline':
                options = $('<ul class="selectBox-options" />');
                options = _getOptions(select, options);
                options
                    .find('A')
                    .on('mouseover.selectBox', function (event) {
                        self.addHover($(this).parent());
                    })
                    .on('mouseout.selectBox',function (event) {
                        self.removeHover($(this).parent());
                    })
                    .on('mousedown.selectBox',function (event) {
                        if (1 !== event.which) {
                            return
                        }
                        event.preventDefault(); // Prevent options from being "dragged"
                        if (!select.selectBox('control').hasClass('selectBox-active')) {
                            select.selectBox('control').focus();
                        }
                    })
                    .on('mouseup.selectBox', function (event) {
                        if (1 !== event.which) {
                            return;
                        }
                        self.hideMenus();
                        self.selectOption($(this).parent(), event);
                    });

                this.disableSelection(options);
                return options;
            case 'dropdown':
                options = $('<ul class="selectBox-dropdown-menu selectBox-options" />');
                options = _getOptions(select, options);

                options
                    .data('selectBox-select', select)
                    .css('display', 'none')
                    .appendTo('BODY')
                    .find('A')
                    .on('mousedown.selectBox', function (event) {
                        if (event.which === 1) {
                            event.preventDefault(); // Prevent options from being "dragged"
                            if (event.screenX === options.data('selectBox-down-at-x') &&
                                event.screenY === options.data('selectBox-down-at-y')) {
                                options.removeData('selectBox-down-at-x').removeData('selectBox-down-at-y');
                                if (/android/i.test(navigator.userAgent.toLowerCase()) &&
                                    /chrome/i.test(navigator.userAgent.toLowerCase())) {
                                    self.selectOption($(this).parent());
                                }
                                self.hideMenus();
                            }
                        }
                    })
                    .on('mouseup.selectBox', function (event) {
                        if (1 !== event.which) {
                            return;
                        }
                        if (event.screenX === options.data('selectBox-down-at-x') &&
                            event.screenY === options.data('selectBox-down-at-y')) {
                            return;
                        } else {
                            options.removeData('selectBox-down-at-x').removeData('selectBox-down-at-y');
                        }
                        self.selectOption($(this).parent());
                        self.hideMenus();
                    })
                    .on('mouseover.selectBox', function (event) {
                        self.addHover($(this).parent());
                    })
                    .on('mouseout.selectBox', function (event) {
                        self.removeHover($(this).parent());
                    });

                // Inherit classes for dropdown menu
                var classes = select.attr('class') || '';
                if ('' !== classes) {
                    classes = classes.split(' ');
                    for (var i = 0; i < classes.length; i++) {
                        options.addClass(classes[i] + '-selectBox-dropdown-menu');
                    }

                }
                this.disableSelection(options);
                return options;
        }
    };

    /**
     * Returns the current class of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getLabelClass = function () {
        var selected = $(this.selectElement).find('OPTION:selected');
        return ('selectBox-label ' + (selected.attr('class') || '')).replace(/\s+$/, '');
    };

    /**
     * Returns the current label of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getLabelText = function () {
        var selected = $(this.selectElement).find('OPTION:selected');
        return selected.text() || '\u00A0';
    };

    /**
     * Sets the label.
     * This method uses the getLabelClass() and getLabelText() methods.
     */
    SelectBox.prototype.setLabel = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        control
            .find('.selectBox-label')
            .attr('class', this.getLabelClass())
            .text(this.getLabelText());
    };

    /**
     * Destroys the SelectBox instance and shows the origin select element.
     *
     */
    SelectBox.prototype.destroy = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        var options = control.data('selectBox-options');
        options.remove();
        control.remove();
        select
            .removeClass('selectBox')
            .removeData('selectBox-control')
            .data('selectBox-control', null)
            .removeData('selectBox-settings')
            .data('selectBox-settings', null)
            .show();
    };

    /**
     * Refreshes the option elements.
     */
    SelectBox.prototype.refresh = function () {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , type = control.hasClass('selectBox-dropdown') ? 'dropdown' : 'inline'
            , options;

        // Remove old options
        control.data('selectBox-options').remove();

        // Generate new options
        options  = this.getOptions(type);
        control.data('selectBox-options', options);

        switch (type) {
            case 'inline':
                control.append(options);
                break;
            case 'dropdown':
                // Update label
                this.setLabel();
                $("BODY").append(options);
                break;
        }

        // Restore opened dropdown state (original menu was trashed)
        if ('dropdown' === type && control.hasClass('selectBox-menuShowing')) {
            this.showMenu();
        }
    };

    /**
     * Shows the dropdown menu.
     */
    SelectBox.prototype.showMenu = function () {
        var self = this
            , select   = $(this.selectElement)
            , control  = select.data('selectBox-control')
            , settings = select.data('selectBox-settings')
            , options  = control.data('selectBox-options');

        if (control.hasClass('selectBox-disabled')) {
            return false;
        }

        this.hideMenus();

        // Get top and bottom width of selectBox
        var borderBottomWidth = parseInt(control.css('borderBottomWidth')) || 0;
        var borderTopWidth = parseInt(control.css('borderTopWidth')) || 0;

        // Get proper variables for keeping options in viewport
        var pos = control.offset()
            , topPositionCorrelation = (settings.topPositionCorrelation) ? settings.topPositionCorrelation : 0
            , bottomPositionCorrelation = (settings.bottomPositionCorrelation) ? settings.bottomPositionCorrelation : 0
            , optionsHeight = options.outerHeight()
            , controlHeight = control.outerHeight()
            , maxHeight = parseInt(options.css('max-height'))
            , scrollPos = $(window).scrollTop()
            , heightToTop = pos.top - scrollPos
            , heightToBottom = $(window).height() - ( heightToTop + controlHeight )
            , posTop = (heightToTop > heightToBottom) && (settings.keepInViewport == null ? true : settings.keepInViewport)
            , top = posTop
                  ? pos.top - optionsHeight + borderTopWidth + topPositionCorrelation
                  : pos.top + controlHeight - borderBottomWidth - bottomPositionCorrelation;


        // If the height to top and height to bottom are less than the max-height
        if(heightToTop < maxHeight&& heightToBottom < maxHeight){

            // Set max-height and top
            if(posTop){
                var maxHeightDiff = maxHeight - ( heightToTop - 5 );
                options.css({'max-height': maxHeight - maxHeightDiff + 'px'});
                top = top + maxHeightDiff;
            }else{
                var maxHeightDiff = maxHeight - ( heightToBottom - 5 );
                options.css({'max-height': maxHeight - maxHeightDiff + 'px'});
            }

        }

        // Save if position is top to options data
        options.data('posTop',posTop);


        // Menu position
        options
            .width(control.innerWidth())
            .css({
                top: top,
                left: control.offset().left
            })
            // Add Top and Bottom class based on position
            .addClass('selectBox-options selectBox-options-'+(posTop?'top':'bottom'));


        if (select.triggerHandler('beforeopen')) {
            return false;
        }

        var dispatchOpenEvent = function () {
            select.triggerHandler('open', {
                _selectBox: true
            });
        };

        // Show menu
        switch (settings.menuTransition) {
            case 'fade':
                options.fadeIn(settings.menuSpeed, dispatchOpenEvent);
                break;
            case 'slide':
                options.slideDown(settings.menuSpeed, dispatchOpenEvent);
                break;
            default:
                options.show(settings.menuSpeed, dispatchOpenEvent);
                break;
        }

        if (!settings.menuSpeed) {
            dispatchOpenEvent();
        }

        // Center on selected option
        var li = options.find('.selectBox-selected:first');
        this.keepOptionInView(li, true);
        this.addHover(li);
        control.addClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));

        $(document).on('mousedown.selectBox', function (event) {
            if (1 === event.which) {
                if ($(event.target).parents().addBack().hasClass('selectBox-options')) {
                    return;
                }
                self.hideMenus();
            }
        });
    };

    /**
     * Hides the menu of all instances.
     */
    SelectBox.prototype.hideMenus = function () {
        if ($(".selectBox-dropdown-menu:visible").length === 0) {
            return;
        }

        $(document).off('mousedown.selectBox');
        $(".selectBox-dropdown-menu").each(function () {
            var options = $(this)
                , select = options.data('selectBox-select')
                , control = select.data('selectBox-control')
                , settings = select.data('selectBox-settings')
                , posTop = options.data('posTop');

            if (select.triggerHandler('beforeclose')) {
                return false;
            }

            var dispatchCloseEvent = function () {
                select.triggerHandler('close', {
                    _selectBox: true
                });
            };
            if (settings) {
                switch (settings.menuTransition) {
                    case 'fade':
                        options.fadeOut(settings.menuSpeed, dispatchCloseEvent);
                        break;
                    case 'slide':
                        options.slideUp(settings.menuSpeed, dispatchCloseEvent);
                        break;
                    default:
                        options.hide(settings.menuSpeed, dispatchCloseEvent);
                        break;
                }
                if (!settings.menuSpeed) {
                    dispatchCloseEvent();
                }
                control.removeClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));
            } else {
                $(this).hide();
                $(this).triggerHandler('close', {
                    _selectBox: true
                });
                $(this).removeClass('selectBox-menuShowing selectBox-menuShowing-'+(posTop?'top':'bottom'));
            }

            options.css('max-height','');
            //Remove Top or Bottom class based on position
            options.removeClass('selectBox-options-'+(posTop?'top':'bottom'));
            options.data('posTop' , false);
        });
    };

    /**
     * Selects an option.
     *
     * @param {HTMLElement} li
     * @param {DOMEvent}    event
     * @returns {Boolean}
     */
    SelectBox.prototype.selectOption = function (li, event) {
        var select = $(this.selectElement);
        li         = $(li);

        var control    = select.data('selectBox-control')
            , settings = select.data('selectBox-settings');

        if (control.hasClass('selectBox-disabled')) {
            return false;
        }

        if (0 === li.length || li.hasClass('selectBox-disabled')) {
            return false;
        }

        if (select.attr('multiple')) {
            // If event.shiftKey is true, this will select all options between li and the last li selected
            if (event.shiftKey && control.data('selectBox-last-selected')) {
                li.toggleClass('selectBox-selected');
                var affectedOptions;
                if (li.index() > control.data('selectBox-last-selected').index()) {
                    affectedOptions = li
                        .siblings()
                        .slice(control.data('selectBox-last-selected').index(), li.index());
                } else {
                    affectedOptions = li
                        .siblings()
                        .slice(li.index(), control.data('selectBox-last-selected').index());
                }
                affectedOptions = affectedOptions.not('.selectBox-optgroup, .selectBox-disabled');
                if (li.hasClass('selectBox-selected')) {
                    affectedOptions.addClass('selectBox-selected');
                } else {
                    affectedOptions.removeClass('selectBox-selected');
                }
            } else if ((this.isMac && event.metaKey) || (!this.isMac && event.ctrlKey)) {
                li.toggleClass('selectBox-selected');
            } else {
                li.siblings().removeClass('selectBox-selected');
                li.addClass('selectBox-selected');
            }
        } else {
            li.siblings().removeClass('selectBox-selected');
            li.addClass('selectBox-selected');
        }

        if (control.hasClass('selectBox-dropdown')) {
            control.find('.selectBox-label').text(li.text());
        }

        // Update original control's value
        var i = 0, selection = [];
        if (select.attr('multiple')) {
            control.find('.selectBox-selected A').each(function () {
                selection[i++] = $(this).attr('rel');
            });
        } else {
            selection = li.find('A').attr('rel');
        }

        // Remember most recently selected item
        control.data('selectBox-last-selected', li);

        // Change callback
        if (select.val() !== selection) {
            select.val(selection);
            this.setLabel();
            select.trigger('change');
        }

        return true;
    };

    /**
     * Adds the hover class.
     *
     * @param {HTMLElement} li
     */
    SelectBox.prototype.addHover = function (li) {
        li = $(li);
        var select = $(this.selectElement)
            , control   = select.data('selectBox-control')
            , options = control.data('selectBox-options');

        options.find('.selectBox-hover').removeClass('selectBox-hover');
        li.addClass('selectBox-hover');
    };

    /**
     * Returns the original HTML select element.
     *
     * @returns {HTMLElement}
     */
    SelectBox.prototype.getSelectElement = function () {
        return this.selectElement;
    };

    /**
     * Remove the hover class.
     *
     * @param {HTMLElement} li
     */
    SelectBox.prototype.removeHover = function (li) {
        li = $(li);
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , options = control.data('selectBox-options');

        options.find('.selectBox-hover').removeClass('selectBox-hover');
    };

    /**
     * Checks if the widget is in the view.
     *
     * @param {jQuery}      li
     * @param {Boolean}     center
     */
    SelectBox.prototype.keepOptionInView = function (li, center) {
        if (!li || li.length === 0) {
            return;
        }

        var select = $(this.selectElement)
            , control     = select.data('selectBox-control')
            , options   = control.data('selectBox-options')
            , scrollBox = control.hasClass('selectBox-dropdown') ? options : options.parent()
            , top       = parseInt(li.offset().top -scrollBox.position().top)
            , bottom    = parseInt(top + li.outerHeight());

        if (center) {
            scrollBox.scrollTop(li.offset().top - scrollBox.offset().top + scrollBox.scrollTop() -
                (scrollBox.height() / 2));
        } else {
            if (top < 0) {
                scrollBox.scrollTop(li.offset().top - scrollBox.offset().top + scrollBox.scrollTop());
            }
            if (bottom > scrollBox.height()) {
                scrollBox.scrollTop((li.offset().top + li.outerHeight()) - scrollBox.offset().top +
                    scrollBox.scrollTop() - scrollBox.height());
            }
        }
    };

    /**
     * Handles the keyDown event.
     * Handles open/close and arrow key functionality
     *
     * @param {DOMEvent}    event
     */
    SelectBox.prototype.handleKeyDown = function (event) {
        var select = $(this.selectElement)
            , control        = select.data('selectBox-control')
            , options      = control.data('selectBox-options')
            , settings     = select.data('selectBox-settings')
            , totalOptions = 0, i = 0;

        if (control.hasClass('selectBox-disabled')) {
            return;
        }

        switch (event.keyCode) {
            case 8:
                // backspace
                event.preventDefault();
                this.typeSearch = '';
                break;
            case 9:
            // tab
            case 27:
                // esc
                this.hideMenus();
                this.removeHover();
                break;
            case 13:
                // enter
                if (control.hasClass('selectBox-menuShowing')) {
                    this.selectOption(options.find('LI.selectBox-hover:first'), event);
                    if (control.hasClass('selectBox-dropdown')) {
                        this.hideMenus();
                    }
                } else {
                    this.showMenu();
                }
                break;
            case 38:
            // up
            case 37:
                // left
                event.preventDefault();
                if (control.hasClass('selectBox-menuShowing')) {
                    var prev = options.find('.selectBox-hover').prev('LI');
                    totalOptions = options.find('LI:not(.selectBox-optgroup)').length;
                    i = 0;
                    while (prev.length === 0 || prev.hasClass('selectBox-disabled') ||
                        prev.hasClass('selectBox-optgroup')) {
                        prev = prev.prev('LI');
                        if (prev.length === 0) {
                            if (settings.loopOptions) {
                                prev = options.find('LI:last');
                            } else {
                                prev = options.find('LI:first');
                            }
                        }
                        if (++i >= totalOptions) {
                            break;
                        }
                    }
                    this.addHover(prev);
                    this.selectOption(prev, event);
                    this.keepOptionInView(prev);
                } else {
                    this.showMenu();
                }
                break;
            case 40:
            // down
            case 39:
                // right
                event.preventDefault();
                if (control.hasClass('selectBox-menuShowing')) {
                    var next = options.find('.selectBox-hover').next('LI');
                    totalOptions = options.find('LI:not(.selectBox-optgroup)').length;
                    i = 0;
                    while (0 === next.length || next.hasClass('selectBox-disabled') ||
                        next.hasClass('selectBox-optgroup')) {
                        next = next.next('LI');
                        if (next.length === 0) {
                            if (settings.loopOptions) {
                                next = options.find('LI:first');
                            } else {
                                next = options.find('LI:last');
                            }
                        }
                        if (++i >= totalOptions) {
                            break;
                        }
                    }
                    this.addHover(next);
                    this.selectOption(next, event);
                    this.keepOptionInView(next);
                } else {
                    this.showMenu();
                }
                break;
        }
    };

    /**
     * Handles the keyPress event.
     * Handles type-to-find functionality
     *
     * @param {DOMEvent}    event
     */
    SelectBox.prototype.handleKeyPress = function (event) {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control')
            , options = control.data('selectBox-options')
            , self    = this;

        if (control.hasClass('selectBox-disabled')) {
            return;
        }

        switch (event.keyCode) {
            case 9:
            // tab
            case 27:
            // esc
            case 13:
            // enter
            case 38:
            // up
            case 37:
            // left
            case 40:
            // down
            case 39:
                // right
                // Don't interfere with the keydown event!
                break;
            default:
                // Type to find
                if (!control.hasClass('selectBox-menuShowing')) {
                    this.showMenu();
                }
                event.preventDefault();
                clearTimeout(this.typeTimer);
                this.typeSearch += String.fromCharCode(event.charCode || event.keyCode);
                options.find('A').each(function () {
                    if ($(this).text().substr(0, self.typeSearch.length).toLowerCase() === self.typeSearch.toLowerCase()) {
                        self.addHover($(this).parent());
                        self.selectOption($(this).parent(), event);
                        self.keepOptionInView($(this).parent());
                        return false;
                    }
                });
                // Clear after a brief pause
                this.typeTimer = setTimeout(function () {
                    self.typeSearch = '';
                }, 1000);
                break;
        }
    };

    /**
     * Enables the selectBox.
     */
    SelectBox.prototype.enable = function () {
        var select = $(this.selectElement);
        select.prop('disabled', false);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control.removeClass('selectBox-disabled');
    };

    /**
     * Disables the selectBox.
     */
    SelectBox.prototype.disable = function () {
        var select = $(this.selectElement);
        select.prop('disabled', true);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control.addClass('selectBox-disabled');
    };

    /**
     * Sets the current value.
     *
     * @param {String}      value
     */
    SelectBox.prototype.setValue = function (value) {
        var select = $(this.selectElement);
        select.val(value);
        value = select.val(); // IE9's select would be null if it was set with a non-exist options value

        if (null === value) { // So check it here and set it with the first option's value if possible
            value = select.children().first().val();
            select.val(value);
        }

        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }

        var settings = select.data('selectBox-settings')
            , options = control.data('selectBox-options');

        // Update label
        this.setLabel();

        // Update control values
        options.find('.selectBox-selected').removeClass('selectBox-selected');
        options.find('A').each(function () {
            if (typeof(value) === 'object') {
                for (var i = 0; i < value.length; i++) {
                    if ($(this).attr('rel') == value[i]) {
                        $(this).parent().addClass('selectBox-selected');
                    }
                }
            } else {
                if ($(this).attr('rel') == value) {
                    $(this).parent().addClass('selectBox-selected');
                }
            }
        });

        if (settings.change) {
            settings.change.call(select);
        }
    };

    /**
     * Sets the option elements.
     *
     * @param {String|Object} options
     */
    SelectBox.prototype.setOptions = function (options) {
        var select = $(this.selectElement)
            , control = select.data('selectBox-control');

        switch (typeof(options)) {
            case 'string':
                select.html(options);
                break;
            case 'object':
                select.html('');
                for (var i in options) {
                    if (options[i] === null) {
                        continue;
                    }
                    if (typeof(options[i]) === 'object') {
                        var optgroup = $('<optgroup label="' + i + '" />');
                        for (var j in options[i]) {
                            optgroup.append('<option value="' + j + '">' + options[i][j] + '</option>');
                        }
                        select.append(optgroup);
                    } else {
                        var option = $('<option value="' + i + '">' + options[i] + '</option>');
                        select.append(option);
                    }
                }
                break;
        }

        if (control) {
            // Refresh the control
            this.refresh();
        }
    };

    /**
     * Disables the selection.
     *
     * @param {*} selector
     */
    SelectBox.prototype.disableSelection = function (selector) {
        $(selector).css('MozUserSelect', 'none').on('selectstart', function (event) {
            event.preventDefault();
        });
    };

    /**
     * Generates the options.
     *
     * @param {jQuery} self
     * @param {jQuery} options
     */
    SelectBox.prototype.generateOptions = function (self, options) {
        var li = $('<li />'), a = $('<a />');
        li.addClass(self.attr('class'));
        li.data(self.data());
        a.attr('rel', self.val()).text(self.text());
        li.append(a);
        if (self.attr('disabled')) {
            li.addClass('selectBox-disabled');
        }
        if (self.attr('selected')) {
            li.addClass('selectBox-selected');
        }
        options.append(li);
    };

    /**
     * Extends the jQuery.fn object.
     */
    $.extend($.fn, {
        selectBox: function (method, options) {
            var selectBox;

            switch (method) {
                case 'control':
                    return $(this).data('selectBox-control');
                case 'settings':
                    if (!options) {
                        return $(this).data('selectBox-settings');
                    }
                    $(this).each(function () {
                        $(this).data('selectBox-settings', $.extend(true, $(this).data('selectBox-settings'), options));
                    });
                    break;
                case 'options':
                    // Getter
                    if (undefined === options) {
                        return $(this).data('selectBox-control').data('selectBox-options');
                    }
                    // Setter
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.setOptions(options);
                        }
                    });
                    break;
                case 'value':
                    // Empty string is a valid value
                    if (undefined === options) {
                        return $(this).val();
                    }
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.setValue(options);
                        }
                    });
                    break;
                case 'refresh':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.refresh();
                        }
                    });
                    break;
                case 'enable':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.enable(this);
                        }
                    });
                    break;
                case 'disable':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.disable();
                        }
                    });
                    break;
                case 'destroy':
                    $(this).each(function () {
                        if (selectBox = $(this).data('selectBox')) {
                            selectBox.destroy();
                            $(this).data('selectBox', null);
                        }
                    });
                    break;
                case 'instance':
                    return $(this).data('selectBox');
                default:
                    $(this).each(function (idx, select) {
                        if (!$(select).data('selectBox')) {
                            $(select).data('selectBox', new SelectBox(select, method));
                        }
                    });
                    break;
            }
            return $(this);
        }
    });
})(jQuery);

(function(){var t=[].indexOf||function(t){for(var e=0,n=this.length;e<n;e++)if(e in this&&this[e]===t)return e;return-1},e=[].slice;!function(t,e){"function"==typeof define&&define.amd?define("waypoints",["jquery"],(function(n){return e(n,t)})):e(t.jQuery,t)}(this,(function(n,r){var i,o,l,s,c,u,f,a,h,d,p,y,v,w,g,S;return i=n(r),a=t.call(r,"ontouchstart")>=0,s={horizontal:{},vertical:{}},c=1,f={},u="waypoints-context-id",p="resize.waypoints",y="scroll.waypoints",v=1,w="waypoints-waypoint-ids",g="waypoint",S="waypoints",o=function(){function t(t){var e=this;this.$element=t,this.element=t[0],this.didResize=!1,this.didScroll=!1,this.id="context"+c++,this.oldScroll={x:t.scrollLeft(),y:t.scrollTop()},this.waypoints={horizontal:{},vertical:{}},this.element[u]=this.id,f[this.id]=this,t.on(y,(function(){var t;if(!e.didScroll&&!a)return e.didScroll=!0,t=function(){return e.doScroll(),e.didScroll=!1},r.setTimeout(t,n[S].settings.scrollThrottle)})),t.on(p,(function(){var t;if(!e.didResize)return e.didResize=!0,t=function(){return n[S]("refresh"),e.didResize=!1},r.setTimeout(t,n[S].settings.resizeThrottle)}))}return t.prototype.doScroll=function(){var t,e=this;return t={horizontal:{newScroll:this.$element.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.$element.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}},!a||t.vertical.oldScroll&&t.vertical.newScroll||n[S]("refresh"),n.each(t,(function(t,r){var i,o,l;return l=[],o=r.newScroll>r.oldScroll,i=o?r.forward:r.backward,n.each(e.waypoints[t],(function(t,e){var n,i;return r.oldScroll<(n=e.offset)&&n<=r.newScroll||r.newScroll<(i=e.offset)&&i<=r.oldScroll?l.push(e):void 0})),l.sort((function(t,e){return t.offset-e.offset})),o||l.reverse(),n.each(l,(function(t,e){if(e.options.continuous||t===l.length-1)return e.trigger([i])}))})),this.oldScroll={x:t.horizontal.newScroll,y:t.vertical.newScroll}},t.prototype.refresh=function(){var t,e,r,i=this;return e=!(r=n.isWindow(this.element))&&this.$element.offset(),this.doScroll(),t={horizontal:{contextOffset:r?0:e.left,contextScroll:r?0:this.oldScroll.x,contextDimension:this.$element.width(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:r?0:e.top,contextScroll:r?0:this.oldScroll.y,contextDimension:r?n[S]("viewportHeight"):this.$element.height(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}},n.each(t,(function(t,e){return n.each(i.waypoints[t],(function(t,r){var i,o,l,s,c;if(i=r.options.offset,l=r.offset,o=n.isWindow(r.element)?0:r.$element.offset()[e.offsetProp],n.isFunction(i)?i=i.apply(r.element):"string"==typeof i&&(i=parseFloat(i),r.options.offset.indexOf("%")>-1&&(i=Math.ceil(e.contextDimension*i/100))),r.offset=o-e.contextOffset+e.contextScroll-i,(!r.options.onlyOnScroll||null==l)&&r.enabled)return null!==l&&l<(s=e.oldScroll)&&s<=r.offset?r.trigger([e.backward]):null!==l&&l>(c=e.oldScroll)&&c>=r.offset||null===l&&e.oldScroll>=r.offset?r.trigger([e.forward]):void 0}))}))},t.prototype.checkEmpty=function(){if(n.isEmptyObject(this.waypoints.horizontal)&&n.isEmptyObject(this.waypoints.vertical))return this.$element.off([p,y].join(" ")),delete f[this.id]},t}(),l=function(){function t(t,e,r){var i,o;"bottom-in-view"===(r=n.extend({},n.fn[g].defaults,r)).offset&&(r.offset=function(){var t;return t=n[S]("viewportHeight"),n.isWindow(e.element)||(t=e.$element.height()),t-n(this).outerHeight()}),this.$element=t,this.element=t[0],this.axis=r.horizontal?"horizontal":"vertical",this.callback=r.handler,this.context=e,this.enabled=r.enabled,this.id="waypoints"+v++,this.offset=null,this.options=r,e.waypoints[this.axis][this.id]=this,s[this.axis][this.id]=this,(i=null!=(o=this.element[w])?o:[]).push(this.id),this.element[w]=i}return t.prototype.trigger=function(t){if(this.enabled)return null!=this.callback&&this.callback.apply(this.element,t),this.options.triggerOnce?this.destroy():void 0},t.prototype.disable=function(){return this.enabled=!1},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0},t.prototype.destroy=function(){return delete s[this.axis][this.id],delete this.context.waypoints[this.axis][this.id],this.context.checkEmpty()},t.getWaypointsByElement=function(t){var e,r;return(r=t[w])?(e=n.extend({},s.horizontal,s.vertical),n.map(r,(function(t){return e[t]}))):[]},t}(),d={init:function(t,e){return null==e&&(e={}),null==e.handler&&(e.handler=t),this.each((function(){var t,r,i,s;return t=n(this),i=null!=(s=e.context)?s:n.fn[g].defaults.context,n.isWindow(i)||(i=t.closest(i)),i=n(i),(r=f[i[0][u]])||(r=new o(i)),new l(t,r,e)})),n[S]("refresh"),this},disable:function(){return d._invoke.call(this,"disable")},enable:function(){return d._invoke.call(this,"enable")},destroy:function(){return d._invoke.call(this,"destroy")},prev:function(t,e){return d._traverse.call(this,t,e,(function(t,e,n){if(e>0)return t.push(n[e-1])}))},next:function(t,e){return d._traverse.call(this,t,e,(function(t,e,n){if(e<n.length-1)return t.push(n[e+1])}))},_traverse:function(t,e,i){var o,l;return null==t&&(t="vertical"),null==e&&(e=r),l=h.aggregate(e),o=[],this.each((function(){var e;return e=n.inArray(this,l[t]),i(o,e,l[t])})),this.pushStack(o)},_invoke:function(t){return this.each((function(){var e;return e=l.getWaypointsByElement(this),n.each(e,(function(e,n){return n[t](),!0}))})),this}},n.fn[g]=function(){var t,r;return r=arguments[0],t=2<=arguments.length?e.call(arguments,1):[],d[r]?d[r].apply(this,t):n.isFunction(r)?d.init.apply(this,arguments):n.isPlainObject(r)?d.init.apply(this,[null,r]):r?n.error("The "+r+" method does not exist in jQuery Waypoints."):n.error("jQuery Waypoints needs a callback function or handler option.")},n.fn[g].defaults={context:r,continuous:!0,enabled:!0,horizontal:!1,offset:0,triggerOnce:!1},h={refresh:function(){return n.each(f,(function(t,e){return e.refresh()}))},viewportHeight:function(){var t;return null!=(t=r.innerHeight)?t:i.height()},aggregate:function(t){var e,r,i;return e=s,t&&(e=null!=(i=f[n(t)[0][u]])?i.waypoints:void 0),e?(r={horizontal:[],vertical:[]},n.each(r,(function(t,i){return n.each(e[t],(function(t,e){return i.push(e)})),i.sort((function(t,e){return t.offset-e.offset})),r[t]=n.map(i,(function(t){return t.element})),r[t]=n.unique(r[t])})),r):[]},above:function(t){return null==t&&(t=r),h._filter(t,"vertical",(function(t,e){return e.offset<=t.oldScroll.y}))},below:function(t){return null==t&&(t=r),h._filter(t,"vertical",(function(t,e){return e.offset>t.oldScroll.y}))},left:function(t){return null==t&&(t=r),h._filter(t,"horizontal",(function(t,e){return e.offset<=t.oldScroll.x}))},right:function(t){return null==t&&(t=r),h._filter(t,"horizontal",(function(t,e){return e.offset>t.oldScroll.x}))},enable:function(){return h._invoke("enable")},disable:function(){return h._invoke("disable")},destroy:function(){return h._invoke("destroy")},extendFn:function(t,e){return d[t]=e},_invoke:function(t){var e;return e=n.extend({},s.vertical,s.horizontal),n.each(e,(function(e,n){return n[t](),!0}))},_filter:function(t,e,r){var i,o;return(i=f[n(t)[0][u]])?(o=[],n.each(i.waypoints[e],(function(t,e){if(r(i,e))return o.push(e)})),o.sort((function(t,e){return t.offset-e.offset})),n.map(o,(function(t){return t.element}))):[]}},n[S]=function(){var t,n;return n=arguments[0],t=2<=arguments.length?e.call(arguments,1):[],h[n]?h[n].apply(null,t):h.aggregate.call(null,n)},n[S].settings={resizeThrottle:100,scrollThrottle:30},i.on("load",(function(){return n[S]("refresh")}))}))}).call(this);
//# sourceMappingURL=waypoints.2.0.4.min.js.map

(function(){var n=this,t=n._,r={},e=Array.prototype,i=Object.prototype,u=Function.prototype,a=e.push,o=e.slice,c=e.concat,l=i.toString,f=i.hasOwnProperty,s=e.forEach,p=e.map,h=e.reduce,v=e.reduceRight,d=e.filter,y=e.every,g=e.some,m=e.indexOf,b=e.lastIndexOf,x=Array.isArray,w=Object.keys,_=u.bind,j=function(n){return n instanceof j?n:this instanceof j?void(this._wrapped=n):new j(n)};"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=j),exports._=j):n._=j,j.VERSION="1.5.2";var A=j.each=j.forEach=function(n,t,e){if(null!=n)if(s&&n.forEach===s)n.forEach(t,e);else if(n.length===+n.length){for(var i=0,u=n.length;u>i;i++)if(t.call(e,n[i],i,n)===r)return}else{var a=j.keys(n);for(i=0,u=a.length;u>i;i++)if(t.call(e,n[a[i]],a[i],n)===r)return}};j.map=j.collect=function(n,t,r){var e=[];return null==n?e:p&&n.map===p?n.map(t,r):(A(n,(function(n,i,u){e.push(t.call(r,n,i,u))})),e)};var E="Reduce of empty array with no initial value";j.reduce=j.foldl=j.inject=function(n,t,r,e){var i=arguments.length>2;if(null==n&&(n=[]),h&&n.reduce===h)return e&&(t=j.bind(t,e)),i?n.reduce(t,r):n.reduce(t);if(A(n,(function(n,u,a){i?r=t.call(e,r,n,u,a):(r=n,i=!0)})),!i)throw new TypeError(E);return r},j.reduceRight=j.foldr=function(n,t,r,e){var i=arguments.length>2;if(null==n&&(n=[]),v&&n.reduceRight===v)return e&&(t=j.bind(t,e)),i?n.reduceRight(t,r):n.reduceRight(t);var u=n.length;if(u!==+u){var a=j.keys(n);u=a.length}if(A(n,(function(o,c,l){c=a?a[--u]:--u,i?r=t.call(e,r,n[c],c,l):(r=n[c],i=!0)})),!i)throw new TypeError(E);return r},j.find=j.detect=function(n,t,r){var e;return O(n,(function(n,i,u){return t.call(r,n,i,u)?(e=n,!0):void 0})),e},j.filter=j.select=function(n,t,r){var e=[];return null==n?e:d&&n.filter===d?n.filter(t,r):(A(n,(function(n,i,u){t.call(r,n,i,u)&&e.push(n)})),e)},j.reject=function(n,t,r){return j.filter(n,(function(n,e,i){return!t.call(r,n,e,i)}),r)},j.every=j.all=function(n,t,e){t||(t=j.identity);var i=!0;return null==n?i:y&&n.every===y?n.every(t,e):(A(n,(function(n,u,a){return(i=i&&t.call(e,n,u,a))?void 0:r})),!!i)};var O=j.some=j.any=function(n,t,e){t||(t=j.identity);var i=!1;return null==n?i:g&&n.some===g?n.some(t,e):(A(n,(function(n,u,a){return i||(i=t.call(e,n,u,a))?r:void 0})),!!i)};j.contains=j.include=function(n,t){return null!=n&&(m&&n.indexOf===m?-1!=n.indexOf(t):O(n,(function(n){return n===t})))},j.invoke=function(n,t){var r=o.call(arguments,2),e=j.isFunction(t);return j.map(n,(function(n){return(e?t:n[t]).apply(n,r)}))},j.pluck=function(n,t){return j.map(n,(function(n){return n[t]}))},j.where=function(n,t,r){return j.isEmpty(t)?r?void 0:[]:j[r?"find":"filter"](n,(function(n){for(var r in t)if(t[r]!==n[r])return!1;return!0}))},j.findWhere=function(n,t){return j.where(n,t,!0)},j.max=function(n,t,r){if(!t&&j.isArray(n)&&n[0]===+n[0]&&n.length<65535)return Math.max.apply(Math,n);if(!t&&j.isEmpty(n))return-1/0;var e={computed:-1/0,value:-1/0};return A(n,(function(n,i,u){var a=t?t.call(r,n,i,u):n;a>e.computed&&(e={value:n,computed:a})})),e.value},j.min=function(n,t,r){if(!t&&j.isArray(n)&&n[0]===+n[0]&&n.length<65535)return Math.min.apply(Math,n);if(!t&&j.isEmpty(n))return 1/0;var e={computed:1/0,value:1/0};return A(n,(function(n,i,u){var a=t?t.call(r,n,i,u):n;a<e.computed&&(e={value:n,computed:a})})),e.value},j.shuffle=function(n){var t,r=0,e=[];return A(n,(function(n){t=j.random(r++),e[r-1]=e[t],e[t]=n})),e},j.sample=function(n,t,r){return arguments.length<2||r?n[j.random(n.length-1)]:j.shuffle(n).slice(0,Math.max(0,t))};var k=function(n){return j.isFunction(n)?n:function(t){return t[n]}};j.sortBy=function(n,t,r){var e=k(t);return j.pluck(j.map(n,(function(n,t,i){return{value:n,index:t,criteria:e.call(r,n,t,i)}})).sort((function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||void 0===r)return 1;if(e>r||void 0===e)return-1}return n.index-t.index})),"value")};var F=function(n){return function(t,r,e){var i={},u=null==r?j.identity:k(r);return A(t,(function(r,a){var o=u.call(e,r,a,t);n(i,o,r)})),i}};j.groupBy=F((function(n,t,r){(j.has(n,t)?n[t]:n[t]=[]).push(r)})),j.indexBy=F((function(n,t,r){n[t]=r})),j.countBy=F((function(n,t){j.has(n,t)?n[t]++:n[t]=1})),j.sortedIndex=function(n,t,r,e){for(var i=(r=null==r?j.identity:k(r)).call(e,t),u=0,a=n.length;a>u;){var o=u+a>>>1;r.call(e,n[o])<i?u=o+1:a=o}return u},j.toArray=function(n){return n?j.isArray(n)?o.call(n):n.length===+n.length?j.map(n,j.identity):j.values(n):[]},j.size=function(n){return null==n?0:n.length===+n.length?n.length:j.keys(n).length},j.first=j.head=j.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:o.call(n,0,t)},j.initial=function(n,t,r){return o.call(n,0,n.length-(null==t||r?1:t))},j.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:o.call(n,Math.max(n.length-t,0))},j.rest=j.tail=j.drop=function(n,t,r){return o.call(n,null==t||r?1:t)},j.compact=function(n){return j.filter(n,j.identity)};var M=function(n,t,r){return t&&j.every(n,j.isArray)?c.apply(r,n):(A(n,(function(n){j.isArray(n)||j.isArguments(n)?t?a.apply(r,n):M(n,t,r):r.push(n)})),r)};j.flatten=function(n,t){return M(n,t,[])},j.without=function(n){return j.difference(n,o.call(arguments,1))},j.uniq=j.unique=function(n,t,r,e){j.isFunction(t)&&(e=r,r=t,t=!1);var i=r?j.map(n,r,e):n,u=[],a=[];return A(i,(function(r,e){(t?e&&a[a.length-1]===r:j.contains(a,r))||(a.push(r),u.push(n[e]))})),u},j.union=function(){return j.uniq(j.flatten(arguments,!0))},j.intersection=function(n){var t=o.call(arguments,1);return j.filter(j.uniq(n),(function(n){return j.every(t,(function(t){return j.indexOf(t,n)>=0}))}))},j.difference=function(n){var t=c.apply(e,o.call(arguments,1));return j.filter(n,(function(n){return!j.contains(t,n)}))},j.zip=function(){for(var n=j.max(j.pluck(arguments,"length").concat(0)),t=new Array(n),r=0;n>r;r++)t[r]=j.pluck(arguments,""+r);return t},j.object=function(n,t){if(null==n)return{};for(var r={},e=0,i=n.length;i>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},j.indexOf=function(n,t,r){if(null==n)return-1;var e=0,i=n.length;if(r){if("number"!=typeof r)return n[e=j.sortedIndex(n,t)]===t?e:-1;e=0>r?Math.max(0,i+r):r}if(m&&n.indexOf===m)return n.indexOf(t,r);for(;i>e;e++)if(n[e]===t)return e;return-1},j.lastIndexOf=function(n,t,r){if(null==n)return-1;var e=null!=r;if(b&&n.lastIndexOf===b)return e?n.lastIndexOf(t,r):n.lastIndexOf(t);for(var i=e?r:n.length;i--;)if(n[i]===t)return i;return-1},j.range=function(n,t,r){arguments.length<=1&&(t=n||0,n=0),r=arguments[2]||1;for(var e=Math.max(Math.ceil((t-n)/r),0),i=0,u=new Array(e);e>i;)u[i++]=n,n+=r;return u};var R=function(){};j.bind=function(n,t){var r,e;if(_&&n.bind===_)return _.apply(n,o.call(arguments,1));if(!j.isFunction(n))throw new TypeError;return r=o.call(arguments,2),e=function(){if(!(this instanceof e))return n.apply(t,r.concat(o.call(arguments)));R.prototype=n.prototype;var i=new R;R.prototype=null;var u=n.apply(i,r.concat(o.call(arguments)));return Object(u)===u?u:i}},j.partial=function(n){var t=o.call(arguments,1);return function(){return n.apply(this,t.concat(o.call(arguments)))}},j.bindAll=function(n){var t=o.call(arguments,1);if(0===t.length)throw new Error("bindAll must be passed function names");return A(t,(function(t){n[t]=j.bind(n[t],n)})),n},j.memoize=function(n,t){var r={};return t||(t=j.identity),function(){var e=t.apply(this,arguments);return j.has(r,e)?r[e]:r[e]=n.apply(this,arguments)}},j.delay=function(n,t){var r=o.call(arguments,2);return setTimeout((function(){return n.apply(null,r)}),t)},j.defer=function(n){return j.delay.apply(j,[n,1].concat(o.call(arguments,1)))},j.throttle=function(n,t,r){var e,i,u,a=null,o=0;r||(r={});var c=function(){o=!1===r.leading?0:new Date,a=null,u=n.apply(e,i)};return function(){var l=new Date;o||!1!==r.leading||(o=l);var f=t-(l-o);return e=this,i=arguments,0>=f?(clearTimeout(a),a=null,o=l,u=n.apply(e,i)):a||!1===r.trailing||(a=setTimeout(c,f)),u}},j.debounce=function(n,t,r){var e,i,u,a,o;return function(){u=this,i=arguments,a=new Date;var c=function(){var l=new Date-a;t>l?e=setTimeout(c,t-l):(e=null,r||(o=n.apply(u,i)))},l=r&&!e;return e||(e=setTimeout(c,t)),l&&(o=n.apply(u,i)),o}},j.once=function(n){var t,r=!1;return function(){return r||(r=!0,t=n.apply(this,arguments),n=null),t}},j.wrap=function(n,t){return function(){var r=[n];return a.apply(r,arguments),t.apply(this,r)}},j.compose=function(){var n=arguments;return function(){for(var t=arguments,r=n.length-1;r>=0;r--)t=[n[r].apply(this,t)];return t[0]}},j.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},j.keys=w||function(n){if(n!==Object(n))throw new TypeError("Invalid object");var t=[];for(var r in n)j.has(n,r)&&t.push(r);return t},j.values=function(n){for(var t=j.keys(n),r=t.length,e=new Array(r),i=0;r>i;i++)e[i]=n[t[i]];return e},j.pairs=function(n){for(var t=j.keys(n),r=t.length,e=new Array(r),i=0;r>i;i++)e[i]=[t[i],n[t[i]]];return e},j.invert=function(n){for(var t={},r=j.keys(n),e=0,i=r.length;i>e;e++)t[n[r[e]]]=r[e];return t},j.functions=j.methods=function(n){var t=[];for(var r in n)j.isFunction(n[r])&&t.push(r);return t.sort()},j.extend=function(n){return A(o.call(arguments,1),(function(t){if(t)for(var r in t)n[r]=t[r]})),n},j.pick=function(n){var t={},r=c.apply(e,o.call(arguments,1));return A(r,(function(r){r in n&&(t[r]=n[r])})),t},j.omit=function(n){var t={},r=c.apply(e,o.call(arguments,1));for(var i in n)j.contains(r,i)||(t[i]=n[i]);return t},j.defaults=function(n){return A(o.call(arguments,1),(function(t){if(t)for(var r in t)void 0===n[r]&&(n[r]=t[r])})),n},j.clone=function(n){return j.isObject(n)?j.isArray(n)?n.slice():j.extend({},n):n},j.tap=function(n,t){return t(n),n};var S=function(n,t,r,e){if(n===t)return 0!==n||1/n==1/t;if(null==n||null==t)return n===t;n instanceof j&&(n=n._wrapped),t instanceof j&&(t=t._wrapped);var i=l.call(n);if(i!=l.call(t))return!1;switch(i){case"[object String]":return n==String(t);case"[object Number]":return n!=+n?t!=+t:0==n?1/n==1/t:n==+t;case"[object Date]":case"[object Boolean]":return+n==+t;case"[object RegExp]":return n.source==t.source&&n.global==t.global&&n.multiline==t.multiline&&n.ignoreCase==t.ignoreCase}if("object"!=typeof n||"object"!=typeof t)return!1;for(var u=r.length;u--;)if(r[u]==n)return e[u]==t;var a=n.constructor,o=t.constructor;if(a!==o&&!(j.isFunction(a)&&a instanceof a&&j.isFunction(o)&&o instanceof o))return!1;r.push(n),e.push(t);var c=0,f=!0;if("[object Array]"==i){if(f=(c=n.length)==t.length)for(;c--&&(f=S(n[c],t[c],r,e)););}else{for(var s in n)if(j.has(n,s)&&(c++,!(f=j.has(t,s)&&S(n[s],t[s],r,e))))break;if(f){for(s in t)if(j.has(t,s)&&!c--)break;f=!c}}return r.pop(),e.pop(),f};j.isEqual=function(n,t){return S(n,t,[],[])},j.isEmpty=function(n){if(null==n)return!0;if(j.isArray(n)||j.isString(n))return 0===n.length;for(var t in n)if(j.has(n,t))return!1;return!0},j.isElement=function(n){return!(!n||1!==n.nodeType)},j.isArray=x||function(n){return"[object Array]"==l.call(n)},j.isObject=function(n){return n===Object(n)},A(["Arguments","Function","String","Number","Date","RegExp"],(function(n){j["is"+n]=function(t){return l.call(t)=="[object "+n+"]"}})),j.isArguments(arguments)||(j.isArguments=function(n){return!(!n||!j.has(n,"callee"))}),"function"!=typeof/./&&(j.isFunction=function(n){return"function"==typeof n}),j.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},j.isNaN=function(n){return j.isNumber(n)&&n!=+n},j.isBoolean=function(n){return!0===n||!1===n||"[object Boolean]"==l.call(n)},j.isNull=function(n){return null===n},j.isUndefined=function(n){return void 0===n},j.has=function(n,t){return f.call(n,t)},j.noConflict=function(){return n._=t,this},j.identity=function(n){return n},j.times=function(n,t,r){for(var e=Array(Math.max(0,n)),i=0;n>i;i++)e[i]=t.call(r,i);return e},j.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))};var I={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}};I.unescape=j.invert(I.escape);var T={escape:new RegExp("["+j.keys(I.escape).join("")+"]","g"),unescape:new RegExp("("+j.keys(I.unescape).join("|")+")","g")};j.each(["escape","unescape"],(function(n){j[n]=function(t){return null==t?"":(""+t).replace(T[n],(function(t){return I[n][t]}))}})),j.result=function(n,t){if(null!=n){var r=n[t];return j.isFunction(r)?r.call(n):r}},j.mixin=function(n){A(j.functions(n),(function(t){var r=j[t]=n[t];j.prototype[t]=function(){var n=[this._wrapped];return a.apply(n,arguments),z.call(this,r.apply(j,n))}}))};var N=0;j.uniqueId=function(n){var t=++N+"";return n?n+t:t},j.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var q=/(.)^/,B={"'":"'","\\":"\\","\r":"r","\n":"n","\t":"t","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\t|\u2028|\u2029/g;j.template=function(n,t,r){var e;r=j.defaults({},r,j.templateSettings);var i=new RegExp([(r.escape||q).source,(r.interpolate||q).source,(r.evaluate||q).source].join("|")+"|$","g"),u=0,a="__p+='";n.replace(i,(function(t,r,e,i,o){return a+=n.slice(u,o).replace(D,(function(n){return"\\"+B[n]})),r&&(a+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'"),e&&(a+="'+\n((__t=("+e+"))==null?'':__t)+\n'"),i&&(a+="';\n"+i+"\n__p+='"),u=o+t.length,t})),a+="';\n",r.variable||(a="with(obj||{}){\n"+a+"}\n"),a="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+a+"return __p;\n";try{e=new Function(r.variable||"obj","_",a)}catch(n){throw n.source=a,n}if(t)return e(t,j);var o=function(n){return e.call(this,n,j)};return o.source="function("+(r.variable||"obj")+"){\n"+a+"}",o},j.chain=function(n){return j(n).chain()};var z=function(n){return this._chain?j(n).chain():n};j.mixin(j),A(["pop","push","reverse","shift","sort","splice","unshift"],(function(n){var t=e[n];j.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!=n&&"splice"!=n||0!==r.length||delete r[0],z.call(this,r)}})),A(["concat","join","slice"],(function(n){var t=e[n];j.prototype[n]=function(){return z.call(this,t.apply(this._wrapped,arguments))}})),j.extend(j.prototype,{chain:function(){return this._chain=!0,this},value:function(){return this._wrapped}})}).call(this);
//# sourceMappingURL=underscore.1.5.2.min.js.map

!function(t,e,n){function u(u,o){o=o||u+n;var i=t(),s=u+"."+o+"-special-event";function c(e){t(i).each((function(){var n=t(this);this===e.target||n.has(e.target).length||n.triggerHandler(o,[e.target])}))}t.event.special[o]={setup:function(){1===(i=i.add(this)).length&&t(e).on(s,c)},teardown:function(){0===(i=i.not(this)).length&&t(e).unbind(s)},add:function(t){var e=t.handler;t.handler=function(t,n){t.target=n,e.apply(this,arguments)}}}}t.map("click dblclick mousemove mousedown mouseup mouseover mouseout change select submit keydown keypress keyup".split(" "),(function(t){u(t)})),u("focusin","focus"+n),u("focusout","blur"+n),t.addOutsideEvent=u}(jQuery,document,"outside");
//# sourceMappingURL=jquery.ba-outside-events.1.1.min.js.map

/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false*/

(function (root, factory) {
  if (typeof exports === "object" && exports) {
    factory(exports); // CommonJS
  } else {
    var mustache = {};
    factory(mustache);
    if (typeof define === "function" && define.amd) {
      define(mustache); // AMD
    } else {
      root.Mustache = mustache; // <script>
    }
  }
}(this, function (mustache) {

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var RegExp_test = RegExp.prototype.test;
  function testRegExp(re, string) {
    return RegExp_test.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var Object_toString = Object.prototype.toString;
  var isArray = Array.isArray || function (object) {
    return Object_toString.call(object) === '[object Array]';
  };

  function isFunction(object) {
    return typeof object === 'function';
  }

  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  function escapeTags(tags) {
    if (!isArray(tags) || tags.length !== 2) {
      throw new Error('Invalid tags: ' + tags);
    }

    return [
      new RegExp(escapeRegExp(tags[0]) + "\\s*"),
      new RegExp("\\s*" + escapeRegExp(tags[1]))
    ];
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate(template, tags) {
    tags = tags || mustache.tags;
    template = template || '';

    if (typeof tags === 'string') {
      tags = tags.split(spaceRe);
    }

    var tagRes = escapeTags(tags);
    var scanner = new Scanner(template);

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length) {
          delete tokens[spaces.pop()];
        }
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(tagRes[0]);
      if (value) {
        for (var i = 0, len = value.length; i < len; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push(['text', chr, start, start + 1]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n') {
            stripSpace();
          }
        }
      }

      // Match the opening tag.
      if (!scanner.scan(tagRes[0])) break;
      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(tagRes[1]);
      } else if (type === '{') {
        value = scanner.scanUntil(new RegExp('\\s*' + escapeRegExp('}' + tags[1])));
        scanner.scan(curlyRe);
        scanner.scanUntil(tagRes[1]);
        type = '&';
      } else {
        value = scanner.scanUntil(tagRes[1]);
      }

      // Match the closing tag.
      if (!scanner.scan(tagRes[1])) {
        throw new Error('Unclosed tag at ' + scanner.pos);
      }

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection) {
          throw new Error('Unopened section "' + value + '" at ' + start);
        }
        if (openSection[1] !== value) {
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
        }
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        tagRes = escapeTags(tags = value.split(spaceRe));
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();
    if (openSection) {
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
    }

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens(tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
      case '^':
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case '/':
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function () {
    return this.tail === "";
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function (re) {
    var match = this.tail.match(re);

    if (match && match.index === 0) {
      var string = match[0];
      this.tail = this.tail.substring(string.length);
      this.pos += string.length;
      return string;
    }

    return "";
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function (re) {
    var index = this.tail.search(re), match;

    switch (index) {
    case -1:
      match = this.tail;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, index);
      this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context(view, parentContext) {
    this.view = view == null ? {} : view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function (name) {
    var value;
    if (name in this.cache) {
      value = this.cache[name];
    } else {
      var context = this;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;

          var names = name.split('.'), i = 0;
          while (value != null && i < names.length) {
            value = value[names[i++]];
          }
        } else {
          value = context.view[name];
        }

        if (value != null) break;

        context = context.parent;
      }

      this.cache[name] = value;
    }

    if (isFunction(value)) {
      value = value.call(this.view);
    }

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer() {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null) {
      tokens = cache[template] = parseTemplate(template, tags);
    }

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function (tokens, context, partials, originalTemplate) {
    var buffer = '';

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    var self = this;
    function subRender(template) {
      return self.render(template, context, partials);
    }

    var token, value;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
        value = context.lookup(token[1]);
        if (!value) continue;

        if (isArray(value)) {
          for (var j = 0, jlen = value.length; j < jlen; ++j) {
            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
          }
        } else if (typeof value === 'object' || typeof value === 'string') {
          buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
          if (typeof originalTemplate !== 'string') {
            throw new Error('Cannot use higher-order sections without the original template');
          }

          // Extract the portion of the original template that the section contains.
          value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

          if (value != null) buffer += value;
        } else {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '^':
        value = context.lookup(token[1]);

        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || (isArray(value) && value.length === 0)) {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '>':
        if (!partials) continue;
        value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) buffer += this.renderTokens(this.parse(value), context, partials, value);
        break;
      case '&':
        value = context.lookup(token[1]);
        if (value != null) buffer += value;
        break;
      case 'name':
        value = context.lookup(token[1]);
        if (value != null) buffer += mustache.escape(value);
        break;
      case 'text':
        buffer += token[1];
        break;
      }
    }

    return buffer;
  };

  mustache.name = "mustache.js";
  mustache.version = "0.8.1";
  mustache.tags = [ "{{", "}}" ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function (template, view, partials) {
    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.
  mustache.to_html = function (template, view, partials, send) {
    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

}));

/*
 * Purl (A JavaScript URL parser) v2.3.1
 * Developed and maintanined by Mark Perkins, mark@allmarkedup.com
 * Source repository: https://github.com/allmarkedup/jQuery-URL-Parser
 * Licensed under an MIT-style license. See https://github.com/allmarkedup/jQuery-URL-Parser/blob/master/LICENSE for details.
 */

;(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else {
        window.purl = factory();
    }
})(function() {

    var tag2attr = {
            a       : 'href',
            img     : 'src',
            form    : 'action',
            base    : 'href',
            script  : 'src',
            iframe  : 'src',
            link    : 'href',
            embed   : 'src',
            object  : 'data'
        },

        key = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'fragment'], // keys available to query

        aliases = { 'anchor' : 'fragment' }, // aliases for backwards compatability

        parser = {
            strict : /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,  //less intuitive, more accurate to the specs
            loose :  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ // more intuitive, fails on relative paths and deviates from specs
        },

        isint = /^[0-9]+$/;

    function parseUri( url, strictMode ) {
        var str = decodeURIComponent(encodeURIComponent(url)),
        res   = parser[ strictMode || false ? 'strict' : 'loose' ].exec( str ),
        uri = { attr : {}, param : {}, seg : {} },
        i   = 14;

        while ( i-- ) {
            uri.attr[ key[i] ] = res[i] || '';
        }

        // build query and fragment parameters
        uri.param['query'] = parseString(uri.attr['query']);
        uri.param['fragment'] = parseString(uri.attr['fragment']);

        // split path and fragement into segments
        uri.seg['path'] = uri.attr.path.replace(/^\/+|\/+$/g,'').split('/');
        uri.seg['fragment'] = uri.attr.fragment.replace(/^\/+|\/+$/g,'').split('/');

        // compile a 'base' domain attribute
        uri.attr['base'] = uri.attr.host ? (uri.attr.protocol ?  uri.attr.protocol+'://'+uri.attr.host : uri.attr.host) + (uri.attr.port ? ':'+uri.attr.port : '') : '';

        return uri;
    }

    function getAttrName( elm ) {
        var tn = elm.tagName;
        if ( typeof tn !== 'undefined' ) return tag2attr[tn.toLowerCase()];
        return tn;
    }

    function promote(parent, key) {
        if (parent[key].length === 0) return parent[key] = {};
        var t = {};
        for (var i in parent[key]) t[i] = parent[key][i];
        parent[key] = t;
        return t;
    }

    function parse(parts, parent, key, val) {
        var part = parts.shift();
        if (!part) {
            if (isArray(parent[key])) {
                parent[key].push(val);
            } else if ('object' == typeof parent[key]) {
                parent[key] = val;
            } else if ('undefined' == typeof parent[key]) {
                parent[key] = val;
            } else {
                parent[key] = [parent[key], val];
            }
        } else {
            var obj = parent[key] = parent[key] || [];
            if (']' == part) {
                if (isArray(obj)) {
                    if ('' !== val) obj.push(val);
                } else if ('object' == typeof obj) {
                    obj[keys(obj).length] = val;
                } else {
                    obj = parent[key] = [parent[key], val];
                }
            } else if (~part.indexOf(']')) {
                part = part.substr(0, part.length - 1);
                if (!isint.test(part) && isArray(obj)) obj = promote(parent, key);
                parse(parts, obj, part, val);
                // key
            } else {
                if (!isint.test(part) && isArray(obj)) obj = promote(parent, key);
                parse(parts, obj, part, val);
            }
        }
    }

    function merge(parent, key, val) {
        if (~key.indexOf(']')) {
            var parts = key.split('[');
            parse(parts, parent, 'base', val);
        } else {
            if (!isint.test(key) && isArray(parent.base)) {
                var t = {};
                for (var k in parent.base) t[k] = parent.base[k];
                parent.base = t;
            }
            if (key !== '') {
                set(parent.base, key, val);
            }
        }
        return parent;
    }

    function parseString(str) {
        return reduce(String(str).split(/&|;/), function(ret, pair) {
            try {
                pair = decodeURIComponent(pair.replace(/\+/g, ' '));
            } catch(e) {
                // ignore
            }
            var eql = pair.indexOf('='),
                brace = lastBraceInKey(pair),
                key = pair.substr(0, brace || eql),
                val = pair.substr(brace || eql, pair.length);

            val = val.substr(val.indexOf('=') + 1, val.length);

            if (key === '') {
                key = pair;
                val = '';
            }

            return merge(ret, key, val);
        }, { base: {} }).base;
    }

    function set(obj, key, val) {
        var v = obj[key];
        if (typeof v === 'undefined') {
            obj[key] = val;
        } else if (isArray(v)) {
            v.push(val);
        } else {
            obj[key] = [v, val];
        }
    }

    function lastBraceInKey(str) {
        var len = str.length,
            brace,
            c;
        for (var i = 0; i < len; ++i) {
            c = str[i];
            if (']' == c) brace = false;
            if ('[' == c) brace = true;
            if ('=' == c && !brace) return i;
        }
    }

    function reduce(obj, accumulator){
        var i = 0,
            l = obj.length >> 0,
            curr = arguments[2];
        while (i < l) {
            if (i in obj) curr = accumulator.call(undefined, curr, obj[i], i, obj);
            ++i;
        }
        return curr;
    }

    function isArray(vArg) {
        return Object.prototype.toString.call(vArg) === "[object Array]";
    }

    function keys(obj) {
        var key_array = [];
        for ( var prop in obj ) {
            if ( obj.hasOwnProperty(prop) ) key_array.push(prop);
        }
        return key_array;
    }

    function purl( url, strictMode ) {
        if ( arguments.length === 1 && url === true ) {
            strictMode = true;
            url = undefined;
        }
        strictMode = strictMode || false;
        url = url || window.location.toString();

        return {

            data : parseUri(url, strictMode),

            // get various attributes from the URI
            attr : function( attr ) {
                attr = aliases[attr] || attr;
                return typeof attr !== 'undefined' ? this.data.attr[attr] : this.data.attr;
            },

            // return query string parameters
            param : function( param ) {
                return typeof param !== 'undefined' ? this.data.param.query[param] : this.data.param.query;
            },

            // return fragment parameters
            fparam : function( param ) {
                return typeof param !== 'undefined' ? this.data.param.fragment[param] : this.data.param.fragment;
            },

            // return path segments
            segment : function( seg ) {
                if ( typeof seg === 'undefined' ) {
                    return this.data.seg.path;
                } else {
                    seg = seg < 0 ? this.data.seg.path.length + seg : seg - 1; // negative segments count from the end
                    return this.data.seg.path[seg];
                }
            },

            // return fragment segments
            fsegment : function( seg ) {
                if ( typeof seg === 'undefined' ) {
                    return this.data.seg.fragment;
                } else {
                    seg = seg < 0 ? this.data.seg.fragment.length + seg : seg - 1; // negative segments count from the end
                    return this.data.seg.fragment[seg];
                }
            }

        };

    }

    purl.jQuery = function($){
        if ($ != null) {
            $.fn.purl_url = function( strictMode ) {
                var url_val = '';
                if ( this.length ) {
                    url_val = $(this).attr( getAttrName(this[0]) ) || '';
                }
                return purl( url_val, strictMode );
            };

            $.purl_url = purl;
        }
    };

    purl.jQuery(window.jQuery);

    return purl;

});

/*
 * jQuery selectBox Default - For selecting the default label option
 *
 * v1.0
 *
 */
;(function ($) {
     /**
     * Returns the default class of the selected option.
     *
     * @returns {String}
     */
    SelectBox.prototype.getDefaultLabelClass = function () {
        var selected = $(this.selectElement).find('OPTION:first');
        return ('selectBox-label ' + (selected.attr('class') || '')).replace(/\s+$/, '');
    };

    SelectBox.prototype.getDefaultLabelText = function () {
        var selected = $(this.selectElement).find('OPTION:first');
        return selected.text() || '\u00A0';
    };

    /**
     * Sets the label.
     * This method uses the getDefaultLabelClass() and getDefaultLabelText() methods.
     */
    SelectBox.prototype.setDefaultLabel = function () {
        var select = $(this.selectElement);
        var control = select.data('selectBox-control');
        if (!control) {
            return;
        }
        control
            .find('.selectBox-label')
            .attr('class', this.getDefaultLabelClass())
            .text(this.getDefaultLabelText());
    };

    /**
     * Extends the jQuery.fn object.
     */
    $.extend($.fn, {
        selectBoxDefault: function (method, options) {

            switch (method) {
                case 'selectDefault':
                    $(this).each(function () {
                        if (selectBoxDefault = $(this).data('selectBox')) {
                            selectBoxDefault.setDefaultLabel();
                            selectBoxDefault.setValue(options);
                        }
                    });
                    break;
                default:
                    $(this).each(function (idx, select) {
                        if (!$(select).data('selectBox')) {
                            $(select).data('selectBox', new SelectBox(select, method));
                        }
                    });
                    break;
            }
            return $(this);
        }
    });
})(jQuery);
var site = site || {};

site.ShadePicker = function (productData) {
    //console.log('init productData: ' + productData.PRODUCT_ID);
    this.init(productData);
};

site.ShadePicker.prototype = {
  productData : null,
  skus: [],
  skuShades : [],
  swatches : '',
  shadeSelects : '',
  originalUrl : window.location.href.split('#/shade/')[0],
  initialShadeRoute : window.location.href.split('#/shade/')[1],
  wireSwatches : function(){
    var self = this;
    self.swatches.on( "click", function(e) {
      e.preventDefault();
      var selectedSkuBaseId = $(this).attr("data-sku-base-id");
      self.updateSwatches(selectedSkuBaseId);
      site.skuSelect(self.skus[selectedSkuBaseId]);
      self.selectShade(selectedSkuBaseId);
    });
    self.swatches.on( "sku:select", function(e, skuData) {
      var selectedSkuBaseId = skuData.SKU_BASE_ID;
      self.updateSwatches(selectedSkuBaseId);
      e.stopPropagation();
    });
    //init first swatch
    self.swatches.eq(0).addClass("selected");
  },
  wireShadeSelects : function() {
    var self = this;
    self.customSelects(true);
    self.shadeSelects.on('change', function(e) {
      var selectedSkuBaseId = $(this).val();
      self.updateSelects(selectedSkuBaseId);
      site.skuSelect(self.skus[selectedSkuBaseId]);
      self.selectShade(selectedSkuBaseId);
    });
    self.shadeSelects.on( "sku:select", function(e, skuData) {
      var selectedSkuBaseId = skuData.SKU_BASE_ID;
      self.updateSelects(selectedSkuBaseId);
      e.stopPropagation();
    });
  },
  customSelects : function(init) {
    var self = this;
    self.shadeSelects.each(function(index, val) {
      if(init){
        $(this).selectBox({ mobile: true });
      }else{
        $(this).selectBox('refresh');
        //self.shadeSelects.selectBox('destroy');
        //self.shadeSelects.selectBox({ mobile: true });
      }
      var $shadeSelect = $(this).selectBox('control');
      var $shadeSelectOption = $($shadeSelect).data('selectBox-options');  // extra $() for iPad
      if(init){
        $(this).selectBoxDefault('selectDefault');
        $('.product-full__quantity').selectBoxDefault('selectDefault');
        $('.spp-product__mini-bag-quantity').selectBoxDefault('selectDefault');
      }

      if(!_.isUndefined($shadeSelectOption) && !_.isNull($shadeSelectOption)){
        var $shadeMenuOptions = $shadeSelectOption.find('li a');
        // add shade divs to custom select
        $shadeMenuOptions.each(function() {
          var shadeSku = $(this).attr('rel');
          //var shadeProductData = _.find(self.skus, function(p){ return p.SKU_BASE_ID == shadeSku; });
          var shadeProductData = _.find(self.productData.skus, function(sku){ return sku.SKU_BASE_ID == shadeSku; });
          var shadeHex = shadeProductData.HEX_VALUE_STRING;

          // explode
          var shadeHex = shadeHex.split(',');

          //sort swathes
          var swatchType, hexValue1, hexValue2, hexValue3, hexValue4, hexValue5;
          if(shadeHex.length == 1) {
            swatchType = 'swatches--single';
            hexValue1 = shadeHex[0];
          }else if(shadeHex.length == 2){
            swatchType = 'swatches--duo';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
          }else if(shadeHex.length == 3){
            swatchType = 'swatches--trio';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
          }else if(shadeHex.length == 4){
            swatchType = 'swatches--quad';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
          }else if(shadeHex.length == 5){
            swatchType = 'swatches--quint';
            hexValue1 = shadeHex[0];
            hexValue2 = shadeHex[1];
            hexValue3 = shadeHex[2];
            hexValue4 = shadeHex[3];
            hexValue5 = shadeHex[4];
          }

          var $swatchContainer = $('<div/>', {
            'class': 'swatch__container ' + swatchType
          });
          for(var i=0; i<shadeHex.length; i++){
            var $swatchDiv = $('<div/>', {
              'class': 'swatch--'+(i+1),
              'style': 'background-color:'+shadeHex[i]
            });
            $swatchContainer.append($swatchDiv);
          }

          // add to li
          $(this).prepend($swatchContainer).clone(true);
          // add to label
          if($(this).parent().hasClass('selectBox-selected')){
            var $shadeSelectLabel = $shadeSelect.parent().find('.selectBox-dropdown');
            if($('.swatch__container',$shadeSelectLabel).length){
              var $clone = $swatchContainer.clone(true);
              $('.swatch__container',$shadeSelectLabel).replaceWith($clone);
            }else{
              var $clone = $swatchContainer.clone(true);
              $shadeSelectLabel.prepend($clone);
            }
          }
           
           //ie8 pie attach behavior
           if ( generic.env.isIE8 ) {
             if (window.PIE) {
               $('.swatches--single div').each(function(i, el) {
                 PIE.attach(this);
               });
             }
           }
        });
      }
    });
  },
  updateSwatches : function(skuId){
    var self = this;
    self.swatches.removeClass("selected");
    self.swatches.filter("[data-sku-base-id=" + skuId +  "]").addClass("selected");
  },
  updateSelects : function(skuId){
    var self = this;
    self.shadeSelects.val(skuId);
    self.customSelects(false);
  },
  fixedEncodeURIComponent : function (str){ //CX-3730 Deep Link Implementation
    try {
      return str.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
    }
    catch(err) {
      // console.log('shadename is undefined');
    }
  },
  hasQueryString : function () { //CX-3730 Deep Link Implementation
    var self = this;
    if (_.isEmpty(self.initialShadeRoute.split('?')[1])) {
      return false;
    } else {
      return true;
    }
  },
  shadeInit : function () { //CX-3730 Deep Link Implementation
    var self = this;
    if (!_.isUndefined(self.initialShadeRoute)) {
      var shadeRoutefromURL = self.initialShadeRoute;
      if (self.hasQueryString()) {
        shadeRoutefromURL = self.initialShadeRoute.split('?')[0];
      }
      var shadeNameNoSpaces = self.fixedEncodeURIComponent(decodeURIComponent(shadeRoutefromURL));
      if (_.contains(self.skuShades, shadeNameNoSpaces)) {
        var foundShadeSkuId = self.skuShades.indexOf(shadeNameNoSpaces);
        $("a.swatch[data-sku-base-id=" + foundShadeSkuId + "]").trigger('click');
      } else {
        self.defaultshadeSelect();
      }
    } else {
      self.defaultshadeSelect();
    }
  },
  selectShade : function (selectedSkuBaseId) { //CX-3730 Deep Link Implementation
    var self = this;
    if (!_.isEmpty(self.skuShades) && Drupal.settings.globals_variables.enable_deep_link) {
      var selectedShade = self.skuShades[selectedSkuBaseId];
      if ( (page_data['custom-spp'] || page_data['catalog-spp']) && $(document).find('.quickshop').length < 1) {
        if (!_.isUndefined(self.initialShadeRoute) && self.hasQueryString()) {
          selectedShade = selectedShade + '?' + self.initialShadeRoute.split('?')[1];
        }
        history.replaceState({}, selectedShade, '#/shade/' + selectedShade);
      }
    }
  },
  defaultshadeSelect : function () {
    var defaultSku = $('a.swatch--selected.selected').data('sku-base-id');
    $("a.swatch[data-sku-base-id=" + defaultSku + "]").trigger('click');
  },
  init: function (productData) {
    var self = this;
    self.productData = productData;
    var pid = self.productData.PRODUCT_ID;
    for (var i=0; i<self.productData.skus.length; i++) {
      var s = self.productData.skus[i];
      self.skus[s.SKU_BASE_ID] = s;
      //CX-3730 Deep Link Implementation
      if (!_.isUndefined(s.SHADENAME) && !_.isNull(s.SHADENAME) && Drupal.settings.globals_variables.enable_deep_link) {
        var shadeNameNoSpaces = self.fixedEncodeURIComponent(s.SHADENAME);
        self.skuShades[s.SKU_BASE_ID] = shadeNameNoSpaces;
      }
      //self.skus.push(s);
    }

    //check for swatches
    self.swatches = $("a.swatch[data-product-id=" + pid + "]");
    if(self.swatches.length > 0){
      self.wireSwatches(self.swatches);
    }
    //check for selects
    self.shadeSelects = $("select.js-sku-menu[data-product-id=" + pid + "]");
    if(self.shadeSelects.length > 0){
      self.wireShadeSelects(self.shadeSelects);
    }
  }
};


site.SmooshSlider = function(args) {
  var that = {
    $list : $(args.containerNode)
  };
  var productData = args.productData;
  //smoosh list
  setTimeout(function(){
    that.$list.slick({
      lazyLoad: 'progressive',
      centerPadding: '50%',
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      onAfterChange: function(slider){
        var $currentSlide = $(slider.$slides).eq(slider.currentSlide);
        var skuBaseId = $currentSlide.attr('data-sku-base-id');
        var skuData = _.find(productData.skus, function(p){ return p.SKU_BASE_ID == skuBaseId; });
        site.skuSelect(skuData);
        //CX-3730 Deep Link Implementation
        site.ShadePicker.prototype.selectShade(skuBaseId);
      }
    });
    $(document).trigger('smoosh_slick_init_ready');
  },200); //give the first image some time to load

  that.$list.on('afterChange', function(event, slick, currentSlide, nextSlide) {
    var skuBaseId = $(slick.$slides).eq(currentSlide).attr('data-sku-base-id');
    $('a.js-swatch[data-sku-base-id=' + skuBaseId + ']', '.js-shade-picker').trigger('click');
  });

  //hook into shade picker
  that.$list.on('sku:select', function(e, skuData) {
    var skuId = skuData.SKU_BASE_ID;
    var $smooshes= $('.smoosh-list-item', that.$list);
    var smooshIndex = $smooshes.filter("[data-sku-base-id=" + skuId + "]").index();
    var currentSlide = that.$list.slick('slickCurrentSlide');
    if(smooshIndex != currentSlide) {
      that.$list.slick('slickGoTo', smooshIndex);
    }
    e.stopPropagation();
  });

  return that;

};


var site = site || {};
site.shadeFilter = {};

site.shadeFilter.init = function() {
  new site.CustomSelects();
};

site.shadeFilter.filter = function() {
  var $swatches = $('.js-swatch', '.js-shade-picker');
  var $shadeFilter = $('.js-custom-select');
  var intensity = '';
  var miscFlag = '';
  var colorFamily = '';
  var $swatchesFiltered = $();
  var $selectedFilter = $();
  $shadeFilter.on('change', function() {
    $selectedFilter = $(this).find(':selected');
    if ($selectedFilter.data('allItems')) {
      $swatches.parent().show();
      $swatches.first().click();
    } else if ($selectedFilter.data('intensityItem')) {
      intensity = $selectedFilter.attr('data-intensity');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-intensity="' + intensity + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    } else if ($selectedFilter.data('miscFlagItem')) {
      miscFlag = $selectedFilter.attr('data-misc-flag');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-misc-flag="' + miscFlag + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    } else if ($selectedFilter.data('colorFamily')) {
      colorFamily = $selectedFilter.data('colorFamily');
      $swatches.parent().hide();
      $swatchesFiltered = $swatches.filter('[data-color-family="' + colorFamily + '"]');
      $swatchesFiltered.parent().show();
      $swatchesFiltered.first().click();
    }
  });
};

site.shadeFilter.loadProductFilterData = function(productData) {
  var p = productData;
  var $prodContainer = $(".js-pr-product[data-product-id='" + p.PRODUCT_ID + "']");
  var showShadeFlag = $prodContainer.data('showShadeFilter') ? true : false;
  if ($prodContainer.length === 0) {
    return p;
  }
  p['enable_mobile_shade_filter'] = showShadeFlag;
  if (showShadeFlag) {
    var skus = p.skus;
    var filteredIntensity = [];
    var filteredMiscFlags = [];
    var filteredColorFamily = [];
    var miscFlag = 0;
    var hexCount = 0;
    var shadeHex = '';
    $(skus).each(function(index, sku) {
    //intensity
      if (!_.isNull(sku['INTENSITY']) && !_.isUndefined(sku['INTENSITY'])) {
        filteredIntensity.push(sku['INTENSITY']);
      }

      //color family
      if (!_.isNull(sku['ATTRIBUTE_COLOR_FAMILY']) && !_.isUndefined(sku['ATTRIBUTE_COLOR_FAMILY'])) {
        filteredColorFamily.push(sku['ATTRIBUTE_COLOR_FAMILY']);
      }

      //misc flags
      if (!_.isNull(sku['MISC_FLAG']) && !_.isUndefined(sku['MISC_FLAG'])) {
        filteredMiscFlags.push(sku['MISC_FLAG']);
        miscFlag = sku['MISC_FLAG'];
        switch (miscFlag) {
          case 1:
            sku['misc_flag_sku_1'] = true;
            break;
          case 2:
            sku['misc_flag_sku_2'] = true;
            break;
          case 3:
            sku['misc_flag_sku_3'] = true;
            break;
          case 5:
          case 94:
            sku['misc_flag_sku_4'] = true;
            break;
          case 15:
            sku['misc_flag_sku_5'] = true;
            break;
          case 126:
            sku['misc_flag_sku_13'] = true;
            break;
        }
      }
      //hex
      shadeHex = sku.HEX_VALUE_STRING;
      // explode
      shadeHex = shadeHex.split(',');
      if (shadeHex.length === 1) {
        sku['SWATCH_TYPE'] = 'single';
      } else if (shadeHex.length === 2) {
        sku['SWATCH_TYPE'] = 'duo';
      } else if (shadeHex.length === 3) {
        sku['SWATCH_TYPE'] = 'trio';
      } else if (shadeHex.length === 5) {
        sku['SWATCH_TYPE'] = 'quint';
      }
      for (var i = 0; i < shadeHex.length; i++) {
        hexCount = i + 1;
        sku['HEX_VALUE_' + hexCount] = shadeHex[i];
      }
    }); // skus
    // intensity
    if (skus.length > 1) {
      filteredIntensity = _.uniq(filteredIntensity);
      if (filteredIntensity.length > 1) {
        p['filtered-intensity'] = filteredIntensity;
        p['filtered_intensity_filter'] = true;
      }

      filteredColorFamily = _.uniq(filteredColorFamily);
      if (filteredColorFamily.length > 1) {
        p['color-family'] = filteredColorFamily;
        p['color-family-show'] = true;
        p['filtered_intensity_filter'] = true;
      }

      filteredMiscFlags = _.uniq(filteredMiscFlags);
      if (filteredMiscFlags.length > 1) {
        $.each(filteredMiscFlags, function(i, v) {
          switch (v) {
            case 1:
              p['misc_flag_filter_1'] = 1;
              break;
            case 2:
              p['misc_flag_filter_2'] = 2;
              break;
            case 3:
              p['misc_flag_filter_3'] = 3;
              break;
            case 5:
              p['misc_flag_filter_4'] = 5;
              break;
            case 94:
              p['misc_flag_filter_4'] = 94;
              break;
            case 15:
              p['misc_flag_filter_5'] = 15;
              break;
            case 30:
              p['misc_flag_filter_6'] = 30;
              break;
            case 17:
              p['misc_flag_filter_7'] = 17;
              break;
            case 116:
              p['misc_flag_filter_8'] = 116;
              break;
            case 121:
              p['misc_flag_filter_9'] = 121;
              break;
            case 122:
              p['misc_flag_filter_10'] = 122;
              break;
            case 124:
              p['misc_flag_filter_11'] = 124;
              break;
            case 125:
              p['misc_flag_filter_12'] = 125;
              break;
            case 126:
              p['misc_flag_filter_13'] = 126;
              break;
            case 128:
              p['misc_flag_filter_14'] = 128;
              break;
          }
        });
        p['filtered_intensity_filter'] = true;
      }
    }
  }
  return p;
};

site.CustomSelects = function() {
  this.init();
};

site.CustomSelects.prototype = {
  selectClass: 'js-custom-select',
  optionClass: 'custom-select-option',
  $selects: $(),

  buildSelects: function() {
    var self = this;
    var customDivMock = '<div data-custom-select-index="" class="custom-select-clone js-custom-select-clone"><div class="custom-select-current select-markdown"><div class="filtered-swatch"></div><div class="selectBox-label"></div><span class="selectBox-arrow"></span></div> <div class="custom-select-options hidden"></div></div>';
    var $customDiv = $();
    var $selectedOption = $();
    var $customOptionsParent = $();
    var customOptionMock = '<li data-custom-option-value="" class="' + self.optionClass + '"></li>';
    var $customOption = $();
    var $customSelected = $();
    var $customSelectOptionsMock = $('<ul class="custom-select-box"></ul>');
    var $customSelectOptions = $();
    var swatchClass = '';
    self.$selects.each(function(i, el) {
      $(el).addClass('custom-select-index' + i);
      $customDiv = $(customDivMock).clone(true);
      $customDiv.attr('data-custom-select-index', i);
      $selectedOption = $(el).find(':selected');
      $customSelected = $customDiv.find('.custom-select-current .selectBox-label');
      $customOptionsParent = $customDiv.find('.custom-select-options');
      $customSelected.html($selectedOption.text());
      $customSelectOptions = $customSelectOptionsMock.clone(true);
      $(el).find('option').each(function(i, op) {
        $customOption = $(customOptionMock).clone(true);
        $customOption.attr('data-custom-option-value', i);
        if ($(op).is(':selected')) {
          $customOption.addClass('active');
        }
        $customOption.html(this.text);
        if ($(op).data('prependCssContainer')) {
          swatchClass = $(op).data('prependCssContainer');
          swatchClass = 'filter-' + swatchClass.toLowerCase().replace(/ /g, '_');
          swatchClass = swatchClass.toLowerCase();
          $customOption.prepend('<div class="filtered-swatch ' + swatchClass + '"></div>');
        }
        $customSelectOptions.append($customOption);
      });
      $customOptionsParent.append($customSelectOptions);
      $(el).addClass('hidden');
      $customDiv.insertAfter($(el));
      $(el).on('change', function() {
        self.refreshSelect($(this));
      });
    });
  },
  refreshSelect: function($el) {
    var self = this;
    var $customDiv = $el.next('.js-custom-select-clone');
    var $selectedOption = $el.find(':selected');
    var $customSelected = $customDiv.find('.custom-select-current');
    var $customSelectLabel = $customSelected.find('.selectBox-label');
    var $filteredSwatch = $('.' + self.optionClass + '.active').find('.filtered-swatch').clone(true);
    var $swatchFilterMock = $('<div class="filtered-swatch"></div>');
    $customSelectLabel.html($selectedOption.text());
    $customSelected.find('.filtered-swatch').remove();
    // if the user selects All shades it has no swatchFilter, its needed to keep the select align
    $filteredSwatch.length ? $customSelected.prepend($filteredSwatch[0]) : $customSelected.prepend($swatchFilterMock[0]);
    $customDiv.find('.custom-select-options').toggleClass('hidden');
    $customSelected.toggleClass('clicked');
  },
  addEvents: function() {
    var self = this;
    var $currentSelect = $();
    var selectIndex = 0;
    var optionIndex = 0;
    $('.' + self.optionClass).on('click', function() {
      $('.' + self.optionClass).removeClass('active');
      $(this).addClass('active');
      selectIndex = $(this).closest('.js-custom-select-clone').attr('data-custom-select-index');
      $currentSelect = $('.custom-select-index' + selectIndex);
      optionIndex = $(this).attr('data-custom-option-value');
      $currentSelect[0].selectedIndex = parseInt(optionIndex);
      $currentSelect.find('option').removeClass('is_active');
      $currentSelect.find('option').eq(optionIndex).addClass('is_active');
      $currentSelect.trigger('change');
    });
    $('.custom-select-current').on('click', function() {
      self.toggleSelect($(this));
    }).on('clickoutside', function() {
      if ($(this).hasClass('clicked')) {
        self.toggleSelect($(this));
      }
    });
  },
  toggleSelect: function($el) {
    var self = this;
    var $currentOptions = $el.next('.custom-select-options');
    $el.toggleClass('clicked');
    self.positionSelectOptions($el, $currentOptions);
    $currentOptions.toggleClass('hidden');
  },
  positionSelectOptions: function($selectedOption, $options) {
    var scrollTop = $(window).scrollTop(),
        elementOffset = $selectedOption.offset().top,
        topSpace = elementOffset - scrollTop;
    var space = screen.height - (topSpace + $selectedOption.outerHeight(true));
    var $clonedOptions = $options.clone(true);
    // we need to display the cloned options outside the viewport, so we can get the
    // elements dinamic height
    $clonedOptions.removeClass('hidden').css({'top': '-9999px', 'display': 'block'});
    $options.parent().append($clonedOptions);
    var optionsHeight = $clonedOptions.find('.custom-select-box').outerHeight(true) + $selectedOption.outerHeight(false) - 1;
    // we remove the clone after getting it's height
    $clonedOptions.remove();
    $options.find('.custom-select-box').removeClass('custom-select-top');
    $selectedOption.removeClass('custom-select-top');
    $options.css('top', '0');
    if (parseInt(space) < parseInt(optionsHeight)) {
      $options.css({'top': '-' + optionsHeight + 'px'});
      $selectedOption.addClass('custom-select-top');
      $options.find('.custom-select-box').addClass('custom-select-top');
    }
  },
  init: function() {
    var self = this;
    self.$selects = $('.' + self.selectClass);
    if (self.$selects.length) {
      $.when(self.buildSelects()).then(self.addEvents());
    }
  },
};

var site = site || {};
var profileRequests = profileRequests || '';
site.profile = site.profile || {};

/**
  * Function that stores any common functionality between PC and Mobile.
  * Any common helper functionality, variables, etc should be added here using the private this object.
  *
*/
site.profile.common = function() {

  // Method to get the profile events class from /personal_block/js/events.js if available.
  var _getEventClass = function() {
    return (site.profile && site.profile.events) ? site.profile.events() : {};
  };

  // Class to handle setting the individual pageview events.
  this.setPageView = {
    mpp : function(id) {
      if (!id) {
        return null;
      };
      this.set({ 'VIEWED_MPP' : id });
    },
    spp : function(id) {
      if (!id) {
        return null;
      };
      this.set({ 'VIEWED_SPP' : id });
    },
    set : function(event) {
      if (!event) {
        return null;
      };

      var eventClass = _getEventClass();
      if (jQuery.isEmptyObject(eventClass)) {
        return null;
      };

      eventClass.store(event);
    }
  };

  // Method to handle the gathering and storing of the page_data for mpp and spp pages.
  this.data = {
    mpp : function(data) {
      if (!data) {
        return null;
      };
      var that      = this;
      var catInfo   = data['categories'] || '';

      return catInfo ? catInfo[0] : {};
    },
    spp : function(data) {
      if (!data) {
        return null;
      };
      var products  = data.products;

      return products ? products[0] : {};
    }
  };

};
window.site = window.site || {};

site.template = (function($) {
  site.templates = site.templates || {};
  site.translations = site.translations || {};

  var defaults = {
    globals: {
      t: site.translations,
      variables: {
        // IE doesn't support location.origin, so...
        site_url: window.location.protocol + '//' + window.location.hostname
      }
    }
  };

  // include config settings from brand common module
  if (typeof Drupal !== 'undefined' && typeof Drupal.settings !== 'undefined' && typeof Drupal.settings.common !== 'undefined') {
    $.extend(defaults.globals.variables, Drupal.settings.common);
  }

  var public = {
    get: function(args) {
      var template = site.templates[args.name];

      // If that didn't work, search for a versioned match of the same template
      // (eg. template_v2)
      if (!template && args.name) {
        for (var key in site.templates) {
          if (site.templates.hasOwnProperty(key)) {
            var matcher = new RegExp(args.name + "_v(\\d+)$");
            if (matcher.test(key)) {
              template = site.templates[key];
              break;
            }
          }
        }
      }

      if (typeof template === 'undefined') {
        console.log('The template ' + args.name + ' cannot be found');
      }

      var rendered = this.render(template, args.data);

      if (typeof args.callback === 'function') {
        var so = args.callback(rendered);
        if (typeof so !== 'undefined') {
          return so;
        }
      }

      return rendered;
    },

    render: function(template, data) {
      defaults.globals.t = site.translations;
      data = data || {};

      // You can pass just the template as a string if you want:
      if (typeof template === 'string') {
        template = {
          content: template,
          data: {}
        };
      }

      var view = $.extend({}, defaults, template.data, data);
      var partials = {};

      if (typeof template.partials !== 'undefined') {
        $.each(template.partials, function(key, name) {
          if (typeof site.templates[key] === 'undefined' && typeof site.templates[name] === 'undefined') {
            console.log('The partial ' + key + ' or ' + name + ' cannot be found');
          }

          var pkey = (typeof site.templates[key] !== 'undefined') ? key : name;
          partials[pkey] = site.templates[pkey].content;
        });
      }

      return Mustache.render(template.content, view, partials);
    }
  };

  return public;
})(
  window.jQuery = window.jQuery || function(){}
);
